
import { Component, Vue, Watch } from "vue-property-decorator";
import { RankingList, StatisticalData, deviceStatus } from "@/views/components";
import deviceItem from "@/views/components/DeviceStatus/deviceItem";
import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
import Scan from "@/views/components/Scan/Scan.vue";
import config from "./config";
import Form3 from "./Form3.vue";
import TableHeader from "./TableHeader.vue";
import Scan2 from "@/views/components/Scan/Scan2.vue";
import DeviceItems2 from "@/views/components/DeviceStatus/DeviceItems2.vue";
import Form2 from "./Form2.vue";

import {
  getAutoCreatedCarCode,
  getCqNoByCpNo,
  getCQInfoByCode,
  querySwitch,
  getOrgCodeListByPage,
  // checklineFrequencys,
  checkCodesAndType,
  newCheckWanted,
  abnormalMovingPartDataUpload,
  abord,
  getWeightForPackage, cloudPress,
  getLineListByPage,
  queryFrontInfo,
  newOperationTotal
} from "@/api/service";
import {CarContainerStatus} from "@/api/serviceHelper"

import * as RuleCheck from "./rulecheck";
import { LogHelper } from "@/common/LogHelper";
import dayjs from "dayjs";
import {
  ApiQueryType,
  OpCodeEnum,
  UploadStateEnum,
  ModeType,
} from "@/common/glboalconstant";
import {
  playSuccessSound,
  playFailSound,
  playWarnSound,
  NoticeVoiceInit,
  playWantedPackSound,
  playCuoFaSound,
  playChaoZaiSound,
  playRoomSound,
  playCuoZhuang,
} from "@/common/voiceTip";
import { playLayerVioce } from "@/common/voiceLayer";

import { ScanforGetOnModule } from "@/store/modules/store_scanforgeton";
import RankingList2 from "@/views/components/RankingList/RankingList2.vue";
import {parseTime} from "@/utils";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";

@Component({
  name: "scanforgeton",
  components: {
    Form2,
    DeviceItems2,
    Scan2,
    deviceStatus,
    RankingList,
    RankingList2,
    StatisticalData,
    YtoTable,
    Form3,
    TableHeader,
    Scan,
  },
})
export default class extends Vue {
  private inputModel: inputDataModel = {
    checked_IsSumWeight: false,
    checked_IsOverTimeCar: false,
    checked_AutoCreateCarCode: false,
    checked_NeedWeight: false,
    input_CarLabel: "",
    checked_CarCodelocked: false,
    input_PacketCode: "",
    input_PanelLine: "",
    input_PanelLineName: "",
    input_NextorgSelect: "",
    input_NextWebPoint: "",
    input_CarNumInfo: "",
    input_RecvType: "",
    checked_RecvTypeLock: false,
    input_Weight: "",
    checked_IsCheckBagWeight: false,
    input_TempWeight: "",
    input_ScanCode: "",
    input_warehouseFlag:"",
    input_StartSoundPlay:false,
    warehouseFlagVisible:true,
    soundPlayDisable:true,
  };

  @Watch("inputModel", { deep: true })
  onChildChanged(val: string) {
    this.asyncSendDataToNet(val);
    this.callbackmodel = val;
  }

  @Watch("inputModel.input_CarLabel")
  onCarLabelChanged(val) {
    if (!val) {
      this.createTimeCQ = null;
    }
  }

  afterSelectNextWebPoint(orgType) {
    if (this.globalConfig.CurrentOrgType !== "BRANCH") {
      return;
    }

    this.nextWebPointOrgType = orgType;
    const isTransferCenter = this.isNextWebPointTransferCenter;
    this.inputModel.soundPlayDisable = !isTransferCenter;
    if (!isTransferCenter) {
      this.inputModel.input_StartSoundPlay = false;
    }
  }

  get isNextWebPointTransferCenter() {
    return this.nextWebPointOrgType === "转运中心";
  }

  private test1(){
    //创建车签主记录
    this.CreateCarCodeMainRecord();
  }

  private CreateCarCodeMainRecord()
  {
    if (this.inputModel.input_CarLabel.length == 0) {
      return;
    } else if (this.inputModel.input_PanelLine.length == 0) {
      return;
    }

    let currentContainNo = this.inputModel.input_CarLabel.toString();
    let mainRecordResponse = this.CreateCarSignNumberMainRecord(currentContainNo);
    // if (mainRecordResponse.respcode  == "231") {
    //   this.errormessage = mainRecordResponse.respMessage;
    // }
  }
  // @Watch("formModel2", { deep: true })
  // onFormmodel2Changed(val: string) {
  //   this.getForm2Value(val);
  // }

  public expType = 10;//实物类型    10:运单  20:包签  30:笼签  40:车签

  public bIsRollInit = false;
  public ytoCommonConfig: any = {};
  public routeNextOrgCode = "";
  private PackageNumInCar = 0;
  private nTotalScanNum = 0;
  public IsCrossBelt = false;
  public globalConfig: any = {};
  public systemConfig: any = {};
  public loginData: any = {};
  public timer; //定时上传功能
  public uploading = false; //正在上传
  public DataQueue = [];
  public nextWebPointOrgType = "";

  public DataQueue_OperationCount = [];
  public timer2; //定时上传功能
  public uploading_OperationRecord = false; //正在上传
  created() {
  }
  mounted() {
    try {
      //设置模式
      if (typeof obj_GlobalData_Core !== "undefined") {
      this.globalConfig = SystemConfigModule.globalData;
      console.log("获取系统配置信息开始");
      console.log(this.globalConfig);
      this.systemConfig = SystemConfigModule.systemData;
      console.log(this.systemConfig);
      this.loginData = SystemConfigModule.loginData;
      console.log(this.loginData);
      console.log("系统配置信息获取结束");
    }
      this.lastCheckCarCodeTime = dayjs().valueOf();//获取当前时间，以便于定时器10分钟之后在检查

      //获取直通模式
      this.routeNextOrgCode = this.GetMode();
      //初始化串口

      try {
        let ytoCommonConfigStr = obj_System_Core.getYtoCommonConfig();
        this.ytoCommonConfig = JSON.parse(ytoCommonConfigStr);
        this.SerialPortInit();
      } catch (error) {}
      debugger;
      //更新重量
      self.setInterval(this.UpdateSumWeight, 20000);

    } catch (error) {
      console.log("上车初始化串口异常:"+error);
    }

    try {
      debugger;
      if (typeof obj_CodeReader_Core !== "undefined") {
        obj_CodeReader_Core.registerJavaScriptCallback(
          "CodeReaderSetPackageData",
          (value) => {
            console.log("相机传输过来的参数");
            console.log(value);
            if (this.isReadCode) {
              this.NoticePlcMsg(this.modeCmd);
            }
            this.setPackageData(value);
          }
        );
      }
      NoticeVoiceInit();
      //初始化设备状态
      this.deviceItems = [];
      for (let index = 1; index <= 12; index++) {
        this.deviceItems.push({
          name: "设备" + index.toString(),
          title: index.toString(),
          status: "defult",
        });
      }
      //初始化统计数据栏目内显示的数据
      this.statisticalList = [
        { label: "总扫描数", value: "0", combine: "1" },
        { label: "车内件数", value: "0", combine: "2" },
        { label: "车内累计重量", value: "0", combine: "3" },
      ];
      console.log("初始化统计数据");
      console.log(this.statisticalList);
    } catch (error) {
      console.log("上车界面:注册回调函数异常" + error);
    }

    var el = document.getElementById("input_scancode_id");
    this.selectElementContents(el);
    try {
      setTimeout(() => {
        obj_ScanForGetOn.vueLoaded();
      }, 0.5 * 1000);
    } catch (error) {
      console.log("上车界面加载界面参数失败" + error);
    }
    this.IsCrossBelt = obj_GlobalData_Core.getIsCrossBelt();
    obj_HttpRequest_Core.registerJavaScriptCallback('dataUploadCallBack', (value) => {
      this.DataUploadCallBack(value);
    });
    try {
          //操作数据上传定时器
    this.timer = setInterval(() => {
      if (this.DataQueue.length) {
        if (this.uploading) {
          return;
        } else {
          try {
            this.uploading = true;
            this.DataUploadNew();
          } catch (error) {
            console.log("error");
            console.log(error);
          } finally {
            this.uploading = false;
          }
        }
      }
    }, 300);
        // 操作量上传定时器
        this.timer2 = setInterval(() => {
      if (this.DataQueue_OperationCount.length) {
        if (this.uploading_OperationRecord) {
          return;
        } else {
          try {
            this.uploading_OperationRecord = true;
            this.DataUpload_OperationRecord();
          } catch (error) {
            console.log("error");
            console.log(error);
          } finally {
            this.uploading_OperationRecord = false;
          }
        }
      }
    }, 300);
    } catch (error) {
      console.error(error);
    }
  }
    // 销毁组件前清除定时器
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.timer2);
  }
public DataUploadNew() {
    try {
      if (this.DataQueue.length > 0) {
        debugger;
        let dataUploadQueueEntity = this.DataQueue.pop();

        let bIsOnlyUploadOpCount = false;

        let callBackEntity: any = {};
        let bIsCollect = false;
        if (!bIsOnlyUploadOpCount) {
          if (dataUploadQueueEntity.OpCode == OpCodeEnum.aboard)
          {
            callBackEntity = this.NewLoading(dataUploadQueueEntity);
          }
          else {
            LogHelper.WriteLog(
              "DataUploadBLL-DataUpload-无效类型：" +
              dataUploadQueueEntity.OpCode.toString()
            );
            return null;
          }

          let _isNeedLayerSound = obj_GlobalData_Core.getIsNeedLayerSound();
          debugger;
          // if (((int)CommonBLL.GetExecuteSubject() == 0) && !ToolsSystemConfig.IsNeedLayerSound)
          if (!_isNeedLayerSound) {

            if (!callBackEntity.IsSuccess)
            {
              if (callBackEntity.extend2 == "1") {
                playCuoFaSound();
                // Thread.Sleep(100);
                setTimeout(() => {
                  playCuoFaSound();
                }, 100);
              } else if (callBackEntity.extend2 == "2") {
                playWantedPackSound();
              } else {
                console.log("debugger 612");
                playFailSound();
              }
            }
            else
            {
              const responseWarehouseFlag = callBackEntity?.Response?.data?.opRecord?.warehouseFlag;
              // 如果勾选了开启语音播报
              if (responseWarehouseFlag === "1")
              {
                const warehouseMsg = callBackEntity?.Response?.data?.opRecord?.warehouseMsg;
                const responseWarehouseNo =  callBackEntity?.Response?.data?.opRecord?.warehouseNo;
                if (responseWarehouseNo >= 1 && responseWarehouseNo <= 9 && warehouseMsg) {
                  playRoomSound(responseWarehouseNo);
                } else if (responseWarehouseNo === 100 || responseWarehouseNo === 101) {
                  playCuoZhuang();
                }
                this.errormessage = warehouseMsg;
              }
              else
              {
                //执行主体是codevision时声音提示
                if (callBackEntity.IsSuccess)
                {
                  playSuccessSound();
                  if (callBackEntity.extend2 == "2") {
                    playWantedPackSound();
                  }
                }
              }
            }
          }
        }

        // dataUploadQueueEntity.CallBack?.Invoke(callBackEntity);
        this.DataUploadCallBack(JSON.stringify(callBackEntity)); //之前的回调方法

        let _expType = dataUploadQueueEntity.bIsPackageCode ? 20 : 10;
        this.OperationCOuntUpload(
          callBackEntity,
          dataUploadQueueEntity,
          bIsCollect,
          _expType
        );

        return callBackEntity;
      }
    } catch (e) {
      LogHelper.Error("DataUploadNew异常:" + e.toString());
      debugger;
    }
  }
  //操作量上传
  public DataUpload_OperationRecord() {
    try {
      if (this.DataQueue_OperationCount.length > 0) {
        let entity = this.DataQueue_OperationCount.pop();

        // System.Threading.Thread.Sleep(30);

        setTimeout(() => {
          debugger;
          var response = JSON.parse(
            newOperationTotal(JSON.stringify(entity.request))
          );
          if (response.respcode == "000") {
            LogHelper.WriteLog("操作数据上传成功");
            //更新本地sqlite操作量的状态
            if (typeof obj_LocalData_Core !== "undefined") {

              obj_LocalData_Core.updateOperationoCountStatus(
                entity.ID,
                entity.request.waybillNo,
                "1"
              );
            }
          } else {
            LogHelper.WriteLog("操作数据上传失败，" + response.respMessage);
            //更新本地sqlite操作量的状态
            if (typeof obj_LocalData_Core !== "undefined") {
              obj_LocalData_Core.updateOperationoCountStatus(
                entity.ID,
                entity.request.waybillNo,
                "2"
              );
            }
          }
        }, 30);
      }
    } catch (e) {
      LogHelper.Error("DataUpload_OperationRecord异常:" + e.toString());
      debugger;
    }
  }
  private InterceptorCode = "-101,-102,-103,-104";
  public OperationCOuntUpload(
    callBackEntity,
    dataUploadQueueEntity,
    bIsCollect,
    ExpType
  ) {
    try {
      debugger;

      //操作量上传
      let bIsUpload = false;
      let obj: any = {};
      let requestDetail: any = {};
      obj = dataUploadQueueEntity.Request;
      requestDetail = dataUploadQueueEntity.Request;

      this.UpdateExpWayBill(dataUploadQueueEntity, callBackEntity, bIsUpload);

      if (!this.IsCrossBelt) {
        //上传成功，重复上传时上传操作量
        if (
          callBackEntity.IsSuccess ||
          (!callBackEntity.IsSuccess && callBackEntity.extend1 == "2")
        ) {
          // JavaScriptSerializer js = new JavaScriptSerializer();
          // var jobj = dataUploadQueueEntity.Request;
          let myJson = "";
          if (bIsCollect) {
            myJson = JSON.stringify(dataUploadQueueEntity.Request);
          } else {
            myJson = JSON.stringify(dataUploadQueueEntity.Request);
          }
debugger;
          this.DataQueue_OperationCount.unshift({
            ID: dataUploadQueueEntity.Id,
            request: {
              compMac: this.globalConfig.LocalMac,
              compIP: this.globalConfig.LocalIPv4,
              devType: dataUploadQueueEntity.devType,
              userCode: this.loginData.userCode,
              userName: this.loginData.userName,

              opCode: parseInt(dataUploadQueueEntity.OpCode.toString()),
              waybillNo: dataUploadQueueEntity.WaybillNo,
              containerNo:
                myJson.indexOf("containerNo") != -1
                  ? requestDetail.body.opRecord.containerNo
                  : "",
              orgCode: this.loginData.orgCode,
              orgName: this.loginData.orgName,
              // userCode : ((int)CommonBLL.GetExecuteSubject() == 1) ? ((jobj.FindTokens("createUserCode").Any()) ? requestDetail.body.opRecord.createUserCode : ((myJson.Contains("takingEmployeeCode")) ? requestDetail.body.opRecord.takingEmployeeCode : "")) : HttpTransport.ServiceConfigHelper.CurrentUserInfo.userCode,
              // userName : ((int)CommonBLL.GetExecuteSubject() == 1) ? ((jobj.FindTokens("createUserName").Any()) ? requestDetail.body.opRecord.createUserName : ((myJson.Contains("employeeName")) ? requestDetail.body.opRecord.employeeName : "")) : HttpTransport.ServiceConfigHelper.CurrentUserInfo.employeeName,
              // orgCode : (((int)CommonBLL.GetExecuteSubject() == 1)) ? requestDetail.body.opRecord.orgCode : HttpTransport.ServiceConfigHelper.CurrentUserInfo.orgCode,
              // orgName : (((int)CommonBLL.GetExecuteSubject() == 1)) ? "" : HttpTransport.ServiceConfigHelper.CurrentUserInfo.orgName,
              prevOrgCode:
                myJson.indexOf("previousOrgCode") != -1
                  ? requestDetail.body.opRecord.previousOrgCode
                  : "",
              nextOrgCode:
                myJson.indexOf("nextOrgCode") != -1
                  ? requestDetail.body.opRecord.nextOrgCode
                  : "",
              destOrgCode: dataUploadQueueEntity.destOrgCode,
              sourceOrgCode: dataUploadQueueEntity.sourceOrgCode,
              ioType:
                myJson.indexOf("ioType") != -1
                  ? requestDetail.body.opRecord.ioType
                  : "01",
              // expType : (jobj.FindTokens("expType").Any()) ? ExpType : 10,
              expType: parseInt(ExpType.toString()),
              optArea:
                myJson.indexOf("optArea") != -1
                  ? requestDetail.body.opRecord.customData.optArea
                  : "",
              latticeNo: dataUploadQueueEntity?.latticeNo,
              effectiveTypeCode:
                myJson.indexOf("effectiveTypeCode") != -1
                  ? requestDetail.body.opRecord.customData.effectiveTypeCode
                  : "",
              volume:
                requestDetail.body.opRecord.pkgLength +
                ";" +
                requestDetail.body.opRecord.pkgWidth +
                ";" +
                requestDetail.body.opRecord.pkgHeight,
              weighWeight:
                myJson.indexOf("weighWeight") != -1
                  ? requestDetail.body.opRecord.weighWeight
                  : "",
              inputWeight:
                myJson.indexOf("inputWeight") != -1
                  ? requestDetail.body.opRecord.inputWeight
                  : "",
              optTime: requestDetail.body.opRecord.createTime,
              extend1: "",
              extend2: "",
              extend3: dataUploadQueueEntity?.daTouBi,
            },
          });
        }
      }
    } catch (ex) {
      LogHelper.Error("操作量转换失败" + ex.toString());
    }
  }
  public UpdateExpWayBill(dataUploadQueueEntity, callBackEntity, bIsUpload) {
    if (typeof obj_LocalData_Core !== "undefined") {

      obj_LocalData_Core.updateExpWayBillCheck(
        {
          // ExecuteSubject : (int)CommonBLL.GetExecuteSubject(),
          ExecuteSubject: 0,
          WaybillNo: dataUploadQueueEntity.WaybillNo,
          Id: dataUploadQueueEntity.Id,
          ModifyTime: dayjs().format("YYYY-MM-DD HH:mm:ss.SSS"),
          Response: JSON.stringify(callBackEntity.Response),
          //操作数据状态标志，0表示未上传，1代表上传成功，2代表上传失败，3代表重复扫描
          Status: (callBackEntity?.Code == null || callBackEntity?.Code == "-999") ? 0 : (callBackEntity.IsSuccess ? 1 : (callBackEntity.extend1 == "2") ? 3 : 2),
          DeviceType: dataUploadQueueEntity.devType,
        },
        bIsUpload ? "1" : "0"
      ); //操作量标志，0表示未上传，1代表上传成功，2表示上传失败
    }
  }
  public NewLoading(dataLoadQueueEntity)
  {
    var response :any= {};
            try
            {
                var request = dataLoadQueueEntity.Request;
                if (dataLoadQueueEntity.bIsPackageCode)
                {
                    request.body.opRecord.expType = "20";
                }
                else
                {
                    request.body.opRecord.expType = "10";
                }
                var retReturn = JSON.parse(abord(JSON.stringify(request)));
                // var retReturn = new HttpTransport.HttpFacade().NewGetOn(request);
                if (retReturn.respcode == "000")
                {
                    response.IsSuccess = true;
                    // 上车车签过期或发车，重新生成上车车签，并且生成130和131记录
                    if (retReturn.data?.opRecord?.waybillType === '8') {
                      this.setCarLabel(retReturn.data?.opRecord?.containerNo);
                      this.createTimeCQ = retReturn.data?.opRecord?.createTimeCQ;
                      const waybillNo = retReturn.data?.opRecord?.waybillNo;
                      const current = this.showList.find((item) => item.code === waybillNo);
                      if (current) {
                        current.CarSignNum = this.inputModel.input_CarLabel;
                      }
                      request.body.opRecord.containerNo = this.inputModel.input_CarLabel;
                    }
                }
                else
                {
                    response.IsSuccess = false;
                    if (retReturn.respcode == "101")
                    {
                        //标记是否重复下车
                        response.extend1 = "2";
                    }
                    else
                    {
                        if ((retReturn.respcode + "").startsWith("-"))
                        {
                            //标记业务上需要拦截的件
                            response.extend1 = "3";
                            if (retReturn.respcode == "-751")
                            {
                                //扩展字段2，1表示路由错发件
                                response.extend2 = "1";
                            }
                            else if (this.InterceptorCode.split(",").indexOf(retReturn.respcode) != -1)
                            {
                                //扩展字段2，2表示拦截件
                                response.extend2 = "2";
                            }
                        }
                        //如果是询问方式
                        if (retReturn.data.feedback.toString() == "COMFIRM")
                        {
                            request.body.isFirstTransfer = "2";
                            // new HttpTransport.HttpFacade().NewGetOn(request);
                            var retReturn1 = JSON.parse(abord(JSON.stringify(request)));
                        }
                    }
                }
                response.Code = retReturn?.respcode;
                // var sjson = retReturn?.data.toString();
                var stReturn :any = {};
                stReturn.respcode = retReturn?.respcode;
                stReturn.respMessage = retReturn.respMessage;
                var _data :any={};
                stReturn.data = _data;

                stReturn.data = retReturn?.data;
                response.Response = stReturn;
                response.resMessage = retReturn?.respMessage;
                response.WaybillNo = request.body.opRecord.waybillNo.toString();
                response.Request = dataLoadQueueEntity;
                // if (response.IsSuccess)
                // {
                //     ToolsOpearation.RefreshLoaclTime(stReturn?.data?.serverTime);
                // }
                return response;
            }
            catch (ex)
            {
                LogHelper.WriteLog("上车接口调用异常, error = " + ex.toString());
                return response;
            }
  }
  public EnqueueFacade(ExpWayBillCheckQueueEntity) {
    this.InsertExpWayBill(ExpWayBillCheckQueueEntity);
    this.DataQueue.unshift(ExpWayBillCheckQueueEntity);
  }
  public InsertExpWayBill(dataUploadQueueEntity) {
    //插库
    if (obj_GlobalData_Core.getTaskExpWayBillCheckStartup()) {
      let dateTimeStr = dayjs().format("YYYY-MM-DD HH:mm:ss.SSS");
      if (typeof obj_LocalData_Core !== "undefined") {

        obj_LocalData_Core.insertExpWayBillCheck({
          CreateTime: dateTimeStr,
          ExecuteSubject: 0,
          Id: dataUploadQueueEntity.Id,
          ModifyTime: dateTimeStr,
          Request: JSON.stringify(dataUploadQueueEntity.Request),
          WaybillNo: dataUploadQueueEntity.WaybillNo,
          Response: "",
          Status: 0, //操作数据上传标识位，0表示为上传，1表示上传成功，2表示上传失败，3表示重复上传
          OpCode: parseInt(dataUploadQueueEntity.OpCode.toString()),
          DeviceType: dataUploadQueueEntity.devType,
          protocolType: this.IsCrossBelt
            ? parseInt(dataUploadQueueEntity.protocolType.toString())
            : 0,
          EXTEND1: "0", //操作量上传标识位，0表示未上传，1表示上传成功，2表示上传失败
          EXTEND2: dataUploadQueueEntity.sourceOrgCode, //存储当前网点
          EXTEND3: dataUploadQueueEntity.destOrgCode, //存储目的网点
          EXTEND4: dataUploadQueueEntity.latticeNo, //存储当前单号所计算出来的格口号
          EXTEND5: dataUploadQueueEntity.daTouBi, //存储当前单号的三段码信息
          EXTEND6: "",
        });
      }
    }
  }
  //增加上车校验是否已经做了发车
  public CheckCurrentCarCode(){
    try {
      if (this.inputModel.input_CarLabel.length == 0) {
        return;
      }
      let _request = {
        devMac: SystemConfigModule.globalData.LocalMac,
        devType: "0",
        body: {
          waybillNo: this.inputModel.input_CarLabel,
          opCodes: "139,140",
          extend1: "",
          extend2: "",
          extend3: ""
        }
      };
      let _response = JSON.parse(queryFrontInfo(JSON.stringify(_request)));
      if (_response.respcode == "000") {
        let clearFlag = false;
        let opType = "发车";
        if (_response.data != null && _response.data.opCode != null) {
          switch (_response.data.opCode) {
            case OpCodeEnum.seal:
              opType = "封车";
              clearFlag = true;
              break;
            case OpCodeEnum.depart:
              opType = "发车";
              clearFlag = true;
              break;
            default:
              clearFlag = false;
              break;
          }
        }
        if (clearFlag) {
          let carLabel = this.inputModel.input_CarLabel;
          this.setCarLabel("");
          this.inputModel.checked_CarCodelocked = false;
          this.$alert( '<p style="font-size:20px;">【' +
              carLabel +
              "】已做"+
              opType +
              "操作，请更换车签后继续操作</p>",
               '提示', {
            confirmButtonText: '确定',
            dangerouslyUseHTMLString: true,
            showClose:false,
          });
        } else {
          //不需要处理
        }
      } else {
        LogHelper.Error("CheckCurrentCarCode接口请求失败：" + _response.respcode + "：" + _response.respMessage);
      }
    } catch (error) {
      LogHelper.Error("CheckCurrentCarCode"+error)
    }

  }
  public SerialPortInit() {
    try {
      let comPort = this.ytoCommonConfig.ComForGetOn;
      let baudRate = this.ytoCommonConfig.PortForGetOn;

      if (
        comPort == null ||
        comPort.length == 0 ||
        baudRate == null ||
        baudRate.length == 0
      ) {
        LogHelper.WriteLog("串口跟波特率为空");
        return;
      }
      debugger;
      let serialPortOpenFlag = obj_SerialPort_Core.isOpen();
      if (!serialPortOpenFlag) {
        let initResult = obj_SerialPort_Core.init(
          comPort,
          Number.parseInt(baudRate),
          8,
          1,
          0
        );
        if (initResult) {
          let openResult = obj_SerialPort_Core.open();
          if (!openResult) {
            LogHelper.WriteLog("串口打开失败");
          } else {
            //串口打开成功，开始添加定时器，监控传过来的参数
            this.bIsRollInit = true;
            this.StartMonitorSerialPort();
          }
        } else {
          LogHelper.WriteLog("串口初始化失败");
        }
      } else {
        this.bIsRollInit = true;
        console.log("皮带秤已经打开，链接成功！");
      }
      //获取串口初始化数据
      this.GetGetOnMissMode();
    } catch (error) {
      LogHelper.WriteLog("串口打开失败:" + error);
    }
  }
  public StartMonitorSerialPort() {
    self.setInterval(this.MonitorSerialPort, 50);
  }
  public MonitorSerialPort() {
    let weightStr = obj_SerialPort_Core.hexRead();
    if (weightStr == null || weightStr.length == 0) {
    } else {
      //解析数据，委托到上车界面处理
      LogHelper.WriteLog("收到的数据为：" + weightStr);
      console.log("收到串口传过来的数据:" + weightStr);
      this.AnalysisData(weightStr);
    }
  }
  public AnalysisData(data) {
    try {
      let tmp = data.trim();

      if (tmp == "8801000016") {
        //起始命令
        this.ReslutForCtrlGetOn(true);
        this.NoticePlcMsg(this.modeCmd);
        this.bIsRollInit;
      } else if (tmp == "8803000016") {
        //结束命令
        this.ReslutForCtrlGetOn(false);
        this.NoticePlcMsg("88 83 00 00 16");
      }
    } catch {
      LogHelper.WriteLog("【上车】解析数据异常");
    }
  }
  public isReadCode = false;
  public ReslutForCtrlGetOn(flag) {
    this.isReadCode = flag;
  }

  public modeCmd = "";
  public stopCmd = "88 87 00 00 16"; //通知plc停止命令
  public GetGetOnMissMode() {
    this.modeCmd = obj_System_Core.getMissMode();
  }
  public m_strValidState = "";
  public setPackageData(data) {
    let _data = JSON.parse(data);
    let _str = {
      DataType: "2",
      code: _data.CodeInfo,
      height: "0.00",
      width: "0.00",
      length: "0.00",
      mac: SystemConfigModule.globalData.LocalMac,
    };
    let stPackageDataStr = JSON.stringify(_str);
    let stPackageData = JSON.parse(stPackageDataStr);
    console.log("上车的core");
    console.log(stPackageData);

    try {
      // this.checkWantedCode = [];
      //是否是包签
      let bIsBagCode = false;
      LogHelper.WriteLog("ScanForGetOn_GetHKInfo;" + stPackageDataStr);
      stPackageData.code = stPackageData.code.toUpperCase().trim();
      // var rg = YTO.Automation.AcceptData.YTOHttpTransport.CheckCodesAndType(stPackageData.code.Split());

      let temps = stPackageData.code.split();
      // var rgStr = checkCodesAndType(JSON.stringify(temps));
      var rgStr = checkCodesAndType(
        temps,
        "131",
        this.inputModel.input_CarLabel
      );
      var rg = JSON.parse(rgStr);

      if (rg.ResultCode != "200")
      {
        debugger;
        this.errormessage = rg.Info;
        this.$nextTick(() => {
          this.NewAbnormalMovingPartUpload(
            stPackageData.code,
            rg.Info,
            this.inputModel.input_RecvType,
            "100"
          );
        });
        return;
      }

      if (rg.ResultCode == "200" && rg.Type == ApiQueryType.strCarCode) {
        LogHelper.WriteLog("上车扫描到车签，过滤");
        return false;
      }

      if (!this.CheckMainData()) {
        return false;
      }

      if (rg.Type == ApiQueryType.strPackageCode) {
        this.expType = 20;//包件
        if (this.inputModel.checked_IsCheckBagWeight) {
          // double dWeight = GetWeight(stPackageData.code);
          // if (!checkWeight(dWeight, stPackageData.code))
          // {
          //     return false;
          // }
          let dWeight = obj_Weight_Core.getWeight(stPackageData.code);
          if (!this.CheckWeight(dWeight, stPackageData.code)) {
            LogHelper.WriteLog(stPackageData.code + "重量校验失败，不上传");
            playFailSound()
            return false;
          }
        }
      }else
      {
        this.expType = 10;//单件
      }

      this.inputModel.input_ScanCode = stPackageData.code;
      //tbx_scanArea.Focus();
      //tbx_scanArea.SelectAll();
      this.errormessage = "";

      if (
        SystemConfigModule.systemData.ModeInfo.Mode_Type == ModeType.CrazeScanOutputType
      ) {
      } else {
        if (this.m_strValidState == "2") {
          playFailSound();
          this.errormessage += "非法件";
          return false;
        }
      }

      // var checkWantedResponse = new YTO.Automation.Business.HttpBLL().NewCheckWanted(stPackageData.code);
      if (!this.NewCheckWanted(stPackageData.code))
      {
        return;
      }

      let strCode = stPackageData.code;
      if (
        stPackageData.code.toUpperCase().startsWith("R02T") ||
        stPackageData.code.toUpperCase().startsWith("R02Z")
      ) {
        strCode = stPackageData.code
          .toUpperCase()
          .replace("R02T", "")
          .replace("R02Z", "");
      }
      this.inputModel.input_PacketCode = stPackageData.code;

      stPackageData.CarSignNum = this.inputModel.input_CarLabel;
      //stPackageData.NextWebPoint = comboBox1.Text;
      stPackageData.NextWebPoint = this.inputModel.input_NextorgSelect;
      stPackageData.optArea = "";
      //stPackageData.RecvType = SCANOBJECT.input_RecvType;
      if (rg.Type == ApiQueryType.strPackageCode) {
        bIsBagCode = true;
      }

      this.FacadeEnqueue(stPackageData, bIsBagCode);
      //PlaySuccessSound();
      this.inputModel.input_ScanCode = "";

      return true;
    } catch (ex) {
      LogHelper.WriteLog("上车出现异常:" + ex);

      return false;
    }
  }
  public dicIoTypeForGetOnFunc(datas) {
    this.dicIoTypeForGetOn = datas;
  }
  public loginDate = "";
  public GlobalConfig = null;
  public carCode = "";
  public sumWeight = "";
  public label_SumWeight = "";
  public lastCheckCarCodeTime = 0;
  //存储单号跟服务器返回时间,存储5个
  public codeAndServiceTime = [];
  public codeCount = 5;
  public createTimeCQ = null;
  public cpCode = "";
  public invalidCpCode = "";  // 未查询到车签的cp码

  public UpdateSumWeight() {
    //当时操作组织是中心的情况下,且非狂扫模式 ，且距离上次更新时间超过了10分钟后，就{1.更新一下时间，2.判断车签是否已经做了封车和发车操作}
    // // try {
    // //   if (SystemConfigModule.globalData.CurrentOrgType == "TRANSFER_CENTER" && SystemConfigModule.systemData.ModeInfo.Mode_Type != ModeType.CrazeScanOutputType && (dayjs().valueOf()-this.lastCheckCarCodeTime)>(10*60*1000)) {
    // //   // if (SystemConfigModule.globalData.CurrentOrgType == "TRANSFER_CENTER" && (dayjs().valueOf()-this.lastCheckCarCodeTime)>(10*1000)) {//测试代码上线前需要注释本行
    // //   //开启10分钟的定时器，判断车签是否需要清空
    // //     this.lastCheckCarCodeTime = dayjs().valueOf();
    // //     this.CheckCurrentCarCode();
    // //   }
    // // } catch (error) {
    // //   console.log("校验车签是否做了封车和发车异常:" + error);
    // // }

    //当当前日期跟车签中日期不一致时（到了第二天），重新换车签
    let today = dayjs();
    if (
      this.loginDate != null &&
      this.loginDate.length > 0 &&
      this.loginDate != today.format("YYMMDD")
    ) {
      if (
        ScanforGetOnModule.checked_AutoCreateCarCode
      ) {
        this.setCarLabel(this.GetAutoCarCode(
          this.inputModel.input_NextWebPoint
        ));
      }
    }
    if (
      this.inputModel.input_CarLabel == null ||
      this.inputModel.input_CarLabel.length == 0 ||
      !ScanforGetOnModule.checked_IsSumWeight
    ) {
      return;
    } else {
      let sumWeight = this.CheckAgainForPackage(
        "130",
        this.inputModel.input_CarLabel
      );
      if (sumWeight == null || sumWeight == undefined || sumWeight.length < 1) {
        return;
      }
      let sumWeightStr = sumWeight.toString();
      // if (sumWeight != null && sumWeightStr.length > 0) {
      console.log(this.statisticalList[2]);
      this.statisticalList[2].value = sumWeightStr.match(/^\d+(?:\.\d{0,2})?/);
      // }
    }
  }
  public panellineValueChangedFunc(id, content) {
    this.panel_line_ValueChanged(id, content);
     this.CreateCarCodeMainRecord();
  }
  public GetMode() {
    try {
      let querySwitchRequest = {
        devMac: SystemConfigModule.globalData.LocalMac.replace(":", "-"), //物理地址中间的分隔符需要为“-”
        devType: "",
        body: {
          queryType: "routeNextOrgCode",
          queryValue: "",
          viewType: "",
          extend1: "",
          extend2: "",
          extend3: "",
        },
      };
      let responseStr = querySwitch(JSON.stringify(querySwitchRequest));
      let response = JSON.parse(responseStr);
      if (response.respcode != "000") {
        LogHelper.WriteLog(
          "上车界面:查询黄埔仓模式出现异常,异常code:" +
            response.respcode +
            ",异常原因:" +
            response.respMessage
        );
        return "0";
      } else {
        return response.data.queryValue;
      }
    } catch (ex) {
      LogHelper.WriteLog("上车界面:查询黄埔仓模式出现异常,异常原因:" + ex);
      return "0";
    }
  }
  public CheckAgainForPackage(operationCode, packageCode) {
    try {
      var weight = "";
      let jbody = {
        queryValue: packageCode,
        queryType: operationCode,
        viewType: null,
        extend1: null,
        extend2: null,
        extend3: null,
      };
      let request = {
        devMac: SystemConfigModule.globalData.LocalMac,
        devType: SystemConfigModule.globalData.CurrentDeviceType.toString(),
        body: jbody,
      };
      let responseStr = getWeightForPackage(JSON.stringify(request));
      let response = JSON.parse(responseStr);
      if (response.respcode === "000") {
        let jresponse = response.data;
        if (jresponse.weight != null) {
          weight = jresponse.weight;
        }
      } else {
        LogHelper.WriteLog("包件重量复核请求失败，" + response.respMessage);
      }
      return weight;
    } catch (error) {
      LogHelper.Error("上车界面:获取重量失败:" + error);
      return "";
    }
  }
  ///以下是原来form2的功能
  public AutoCreateCarCodeChangeFunc(isChecked) {
    debugger;
    if (isChecked) {
      if (this.inputModel.checked_CarCodelocked) {
        this.errormessage = "请先取消勾选车签锁定框";
        this.$nextTick(() => {
          // this.formModel2.checked_AutoCreateCarCode = false;
          ScanforGetOnModule.AutoCreateCarCodeChangeState(false);
        });
        return;
      }
      if (
        this.inputModel.input_NextWebPoint === null ||
        this.inputModel.input_NextWebPoint === undefined ||
        this.inputModel.input_NextWebPoint === ""
      ) {
        if (this.routeNextOrgCode === "1") {
          //如果是黄埔仓模式，那么就不需要校验下一网点，可以勾选
          this.$nextTick(() => {
            // this.formModel2.checked_AutoCreateCarCode = true;
            ScanforGetOnModule.AutoCreateCarCodeChangeState(true);
          });
        } else {
          //当勾选自动生成车签时，且下一网点为空
          this.errormessage = "该线路无法自动生成车签";
          // this.inputModel.input_CarLabel = "";
          this.$nextTick(() => {
            // this.formModel2.checked_AutoCreateCarCode = false;
            ScanforGetOnModule.AutoCreateCarCodeChangeState(false);

            console.log("2设置自动生成车签为false");
          });
        }
      } else {
        //当勾选自动生成车签时，且下一网点不为空
        this.errormessage = "";
        var _nextwebpoint = this.inputModel.input_NextWebPoint;
        var orgs = this.nextOrgsOption;
        var orgtype = "";
        if (orgs !== null) {
          orgs.forEach((element) => {
            if (element.value === _nextwebpoint) {
              orgtype = element.orgtype;
            }
          });
        }

        if (orgtype === "转运中心") {
          this.errormessage = "该线路无法自动生成车签";

          // this.inputModel.input_CarLabel = "";
          this.$nextTick(() => {
            // this.formModel2.checked_AutoCreateCarCode = false;
            ScanforGetOnModule.AutoCreateCarCodeChangeState(false);

            console.log("3设置自动生成车签为false");
          });
        } else {
          var carcode = this.GetAutoCarCode(_nextwebpoint);
          this.setCarLabel(carcode);
          ScanforGetOnModule.AutoCreateCarCodeChangeState(true);
          this.CreateCarCodeMainRecord();
        }
      }
    } else {
      //当取消勾选自动生成车签的勾选框时
      this.setCarLabel("");
      this.errormessage = "";
      ScanforGetOnModule.AutoCreateCarCodeChangeState(false);
    }
  }

  public ChooseNextWebPoint(nextWebPoint) {
    if (nextWebPoint == "") {
      this.nextWebPointOrgType = "";
      return;
    }
    var _nextwebpoint = nextWebPoint;
    var orgs = this.nextOrgsOption;
    var orgtype = "";
    if (orgs !== null) {
      orgs.forEach((element) => {
        if (element.value === _nextwebpoint) {
          orgtype = element.orgtype;
        }
      });
    }

    this.afterSelectNextWebPoint(orgtype);

    // if (this.formModel2.checked_AutoCreateCarCode) {
    if (ScanforGetOnModule.checked_AutoCreateCarCode) {
      if (orgtype == "转运中心") {
        this.errormessage = "该线路无法自动生成车签";
        this.setCarLabel("");
        // this.formModel2.checked_AutoCreateCarCode = false;
        ScanforGetOnModule.AutoCreateCarCodeChangeState(false);

        console.log("1设置自动生成车签为false");
      } else {
        var carcode = this.GetAutoCarCode(_nextwebpoint);
        this.setCarLabel(carcode);
      }
    } else {
      console.log("未勾选自动生成车签");
    }
  }

  // public formModel2: any = {
  //   checked_IsSumWeight: false,
  //   checked_IsOverTimeCar: false,
  //   checked_AutoCreateCarCode: false,
  //   checked_NeedWeight: false,
  // };

  public nextOrgsOption = [];

  public nextorgscallback(datas) {
    var jsonobj = datas;
    let options_NextOrg = [];
    if (jsonobj.data.busiDataArray != null) {
      jsonobj.data.busiDataArray.forEach((element) => {
        options_NextOrg.push({
          label: element.endOrgName,
          value: element.endOrgCode,
          orgtype: element.endOrgType,
        });
      });
    }
    return options_NextOrg;
  }
  public storeNextOrgs(datas) {
    this.nextOrgsOption = this.nextorgscallback(datas);
    ScanforGetOnModule.NextOrgOptionsSet(this.nextOrgsOption);
  }

  public asyncSendDataToNet(data) {
  }

  //上传成功,为黑色，其他都是红色
  private rowClassAction(row) {
    if (/失败/.test(row.row.UploadStateName)) {
      return { color: "#f22613", "font-size": "130%", "font-weight": "bold" };
    }
    if (/重复/.test(row.row.UploadStateName)) {
      return { color: "#f22613", "font-size": "130%", "font-weight": "bold" };
    }
  }

  private getFormValue(element) {
    this.inputModel.input_NextWebPoint = element.input_NextWebPoint;
    this.inputModel.input_CarNumInfo = element.input_CarNumInfo;
    this.inputModel.input_RecvType = element.input_RecvType;
    this.inputModel.checked_RecvTypeLock = element.checked_RecvTypeLock;
    this.inputModel.input_Weight = element.input_Weight;
    this.inputModel.checked_IsCheckBagWeight = element.checked_IsCheckBagWeight;
    this.inputModel.input_TempWeight = element.input_TempWeight;
    this.inputModel.input_ScanCode = element.input_ScanCode;
    this.inputModel.input_CarLabel = element.input_CarLabel;
    this.inputModel.checked_CarCodelocked = element.checked_CarCodelocked;
    this.inputModel.input_PacketCode = element.input_PacketCode;
    this.inputModel.input_PanelLine = element.input_PanelLine;
    this.inputModel.input_PanelLineName = element.input_PanelLineName;
    this.inputModel.input_NextorgSelect = element.input_NextorgSelect;
  }

  private getForm2Value(element) {
    this.inputModel.checked_IsSumWeight = element.checked_IsSumWeight;
    this.inputModel.checked_IsOverTimeCar = element.checked_IsOverTimeCar;
    this.inputModel.checked_AutoCreateCarCode =
      element.checked_AutoCreateCarCode;
    this.inputModel.checked_NeedWeight = element.checked_NeedWeight;
    console.log(element);
  }

  private currentRowChanged(element) {
    this.currentrow = element;
  }

  //获得焦点，选中文本
  private getInputFocus(event): void {
    event.currentTarget.select();
  }

  // //更新设备状态数据
  // public getdevicestatecallback(datas): void {
  //   this.deviceItems = [];
  //   this.deviceItems = datas;
  // }
  public ClearData() {
    debugger;
    if (
      this.routeNextOrgCode === "1" &&
      ScanforGetOnModule.checked_AutoCreateCarCode
    ) {
      if (!this.inputModel.checked_CarCodelocked) {
        this.setCarLabel("");
      }
      this.inputModel.input_NextorgSelect = "";
      this.inputModel.input_NextWebPoint = "";
    }
  }
  //更新数据列表的数据
  public datahistorycallback(data) {
    this.showList = [];
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      if (index == 0 && element.UploadStateName == "上传成功") {
        // YT2600191827105
        this.ClearData();
      }
      var str_datetime =
        element.ScanTime.getFullYear() +
        "-" +
        (element.ScanTime.getMonth() + 1 < 10 ? "0" : "") +
        (element.ScanTime.getMonth() + 1) +
        "-" +
        (element.ScanTime.getDate() < 10 ? "0" : "") +
        element.ScanTime.getDate() +
        " " +
        (element.ScanTime.getHours() < 10 ? "0" : "") +
        element.ScanTime.getHours() +
        ":" +
        (element.ScanTime.getMinutes() < 10 ? "0" : "") +
        element.ScanTime.getMinutes() +
        ":" +
        (element.ScanTime.getSeconds() < 10 ? "0" : "") +
        element.ScanTime.getSeconds();
      this.showList.push({
        index: element.index,
        code: element.code,
        CarSignNum: element.CarSignNum,
        RecvType: element.RecvType,
        NextWebPoint: element.NextWebPoint,
        Line: element.Line,
        ScanTime: str_datetime,
        UploadStateName: element.UploadStateName,
        Info: element.Info,
        state: element.UploadStateName,
      });
    }
  }

  //错误消息回调显示方法
  public errormsgcallback(data) {
    this.errormessage = data;
  }

  //统计数据回显
  public statisticaldatacallback(data) {
    data.forEach((element) => {
      if (element.Key == "totalScanCount") {
        this.statisticalList[0].value = element.Value;
      }
      if (element.Key == "piecesCountInCar") {
        this.statisticalList[1].value = element.Value;
      }
      if (element.Key == "totalWeight") {
        this.statisticalList[2].value = element.Value;
      }
    });
  }

  public msg = "";
  private config = config;
  private statisticalList = [];
  public currentrow = null;
  public showList = [];
  public ytoCode = "";

  public GetAutoCarCode(nextOrgCode) {
    let carCode = "";
    try {
      let jbody = {
        queryValue: nextOrgCode,
        queryType: "",
        viewType: "",
        extend1: null,
        extend2: null,
        extend3: null,
        lineNo: this.inputModel.input_PanelLine,
      };
      let request = {
        devMac: SystemConfigModule.globalData.LocalMac,
        devType: SystemConfigModule.globalData.CurrentDeviceType.toString(),
        body: jbody,
      };
      var responseStr = getAutoCreatedCarCode(JSON.stringify(request));
      var response = JSON.parse(responseStr);

      if (response == null || response.isSuccess == false) {
        LogHelper.WriteLog("获取");
      }
      let jresponse = response?.data;
      if (jresponse == null) {
        return carCode;
      }
      if (jresponse.waybillno != null) {
        carCode = jresponse.waybillno;
        this.loginDate = dayjs().format("YYMMDD");
        this.setCarLabel(carCode);
        this.carCode = carCode;
        this.statisticalList[2].value = "0";
        this.createTimeCQ = jresponse.createTimeCQ;
      }
    } catch (ex) {
      LogHelper.Warn("获取车牌出现异常:" + ex);
    }
    return carCode;
  }
  //根据CP码查询CQ
  private DoWithCarInfoCode(carCodeInfo) {
    let carCode = "";
    try {
      let jbody = {
        queryValue: carCodeInfo,
        queryType: "30",
        viewType: "",
        extend1: "1", //1表示上车、2表示下车
        extend2: "",
        extend3: "",
      };

      let request = {
        devMac: SystemConfigModule.globalData.LocalMac,
        devType: SystemConfigModule.globalData.CurrentDeviceType.toString(),
        body: jbody,
      };
      let responseStr = getCqNoByCpNo(JSON.stringify(request));
      let response = JSON.parse(responseStr);
      let jresponse = response.data;
      if (jresponse.extend1 != null) {
        carCode = jresponse.extend1;
        this.createTimeCQ = jresponse.createTimeCQ;
      }
    } catch (ex) {
      LogHelper.WriteLog("上车 DoWithCarInfoCode" + ex);
    }
    return carCode;
  }
  //根据车签查询车牌接口
  private GetCarNumInfoByCQ(carcode) {
    try {
      let jbody = {
        viewType: "1",
        queryValue: carcode,
        queryType: "17",
      };
      let request = {
        devMac: SystemConfigModule.globalData.LocalMac,
        devType: SystemConfigModule.globalData.CurrentDeviceType.toString(),
        body: jbody,
      };
      let responseStr = getCQInfoByCode(JSON.stringify(request));
      if (responseStr == null || responseStr.length == 0) {
        LogHelper.WriteLog("车签查询失败, 错误信息:" + "返回的内容为空");
        return;
      }
      let response = JSON.parse(responseStr);

      if (response == null || response.isSuccess == false) {
        LogHelper.WriteLog(
          "车签查询失败, 错误信息:" +
            response?.respMessage +
            "，错误代码：" +
            response?.respcode +
            "警告"
        );
      }
      let jresponse = response?.data;
      if (
        jresponse == null ||
        (jresponse.carNumber == null && jresponse.carNumberExtend == null)
      ) {
        LogHelper.WriteLog("查询不到该车签对应的运营单，请创单后再进行过磅！");
      } else {
        if (jresponse.carNumberExtend != null) {
          let result = jresponse.carNumberExtend;
          if (!(result != null || result.length < 1)) {
            this.inputModel.input_CarNumInfo = result;
            return;
          }
        }
        if (jresponse.carNumber != null) {
          this.inputModel.input_CarNumInfo = jresponse.carNumber;
        }
      }
    } catch (ex) {
      LogHelper.WriteLog("根据车签查询车牌接口异常" + ex);
    }
    return;
  }
  //获取车签信息
  private GetCQInfoByCode(scancontent) {
    let request = {
      devType: "0",
      devMac: SystemConfigModule.globalData.LocalMac,
      body: {
        viewType: "1",
        queryValue: scancontent,
        queryType: "17",
      },
    };
    let responseStr = getCQInfoByCode(JSON.stringify(request));
    let response = JSON.parse(responseStr);
    return response;
  }
  public checkWantedCode = [];
  private linePrefixRuleIds = [
    "ENT",
    "LTL",
    "FLT",
    "MOT",
    "OTH",
    "WAC",
    "RAL",
    "TPL",
    "RAL",
    "BUS",
    "TFS",
  ]; //合法的线路号前缀集合
  public showDataModel: any = {};
  //扫描区扫码
  private ytocodeget() {
    debugger;
    this.inputModel.input_ScanCode = this.ytoCode.toUpperCase();
    try {
      this.errormessage = "";
      // this.checkWantedCode = [];
      let scanAreaContent = this.inputModel.input_ScanCode.toUpperCase().trim();
      if (scanAreaContent == "") {
        try {
          playWarnSound();
          this.errormessage = "输入为空";
          return;
        } catch (ex) {
          this.errormessage = "输入为空,警告提示音不存在";
          return;
        }
      }
      var reg1 = new RegExp(/^[0-9A-Za-z]+$/);
      if (!reg1.test(scanAreaContent)) {
        this.errormessage = "输入数据非法，只能输入数字和字母";
        return;
      }

      /*obj_Camera_Core.cameraBLLEnqueueFacade(
        scanAreaContent,
        OpCodeEnum.aboard,
        SystemConfigModule.loginData.employeeName,
        this.inputModel.input_NextWebPoint,
        "上车"
      );*/
      // //
      // // YTO.Automation.Business.CameraBLL.EnqueueFacade(new CameraPrintCodeEntity()
      // //       {
      // //           WayBillNo = scanAreaContent,
      // //           OpCodeEnum = YTO.Automation.Model.HttpModel.OpCodeEnum.debus,
      // //           UserName = m_stLoginReturn.employeeName,
      // //           NextOrgCode = this.inputModel.input_NextWebPoint,
      // //           OpName = "上车"
      // //       });
      // //

      try {
        //tbx_scanArea.SelectAll();
        let bReturnState = true;

        let bIsolationCloth = false; //是否是隔离布
        var regGLB = new RegExp(/^GLB[0-9]{6}$/);
        if (regGLB.test(scanAreaContent)) {
          //匹配到隔离布
          bIsolationCloth = true;
        }

        let flag = false;
        if (scanAreaContent.length >= 10 || bIsolationCloth) {
          flag = this.LinePreFixRuleCheck(scanAreaContent);
          console.log("lineRuleFlag:" + flag);
          if (!flag) {
            let temps = [];
            temps.push(scanAreaContent);
            debugger;
            var rgStr = checkCodesAndType(
              temps,
              "131",
              this.inputModel.input_CarLabel
            );
            var rg = JSON.parse(rgStr);

            if(rg.ResultCode != "200")
            {
              this.errormessage = rg.Info;
              this.$nextTick(() => {
                this.NewAbnormalMovingPartUpload(
                  scanAreaContent,
                  rg.Info,
                  this.inputModel.input_RecvType,
                  "100"
                );
              });
              return;
            }
            if (bIsolationCloth) {
              rg.ResultCode = "200";
              rg.Type = ApiQueryType.strWayBillCode;
            }

            let cpCode = "";
            if (rg.ResultCode == "200") {
              //如果当前为CP码
              let bIsCpCode = false;
              if (rg.Type == ApiQueryType.strCarInfoCode) {
                bIsCpCode = true;
                cpCode = scanAreaContent;
                let carCode = this.DoWithCarInfoCode(scanAreaContent);
                if (carCode == null || carCode.length < 1) {
                  this.invalidCpCode = cpCode;
                  this.errormessage =
                    "未查询到车签号，请重扫或直接扫描车签号条码！";
                  this.$nextTick(() => {
                    this.ytoCode = scanAreaContent;
                    this.$nextTick(() => {
                      var el = document.getElementById("input_scancode_id");
                      this.selectElementContents(el);
                    });
                  });
                  return;
                } else {
                  if (this.invalidCpCode) {
                    this.invalidCpCode = "";
                  }
                  scanAreaContent = carCode;
                  this.CreateCarCodeMainRecord();
                  this.GetCarNumInfoByCQ(scanAreaContent);
                }
              }

              //如果当前为车签
              if (rg.Type == ApiQueryType.strCarCode || bIsCpCode) {
                if (this.inputModel.checked_CarCodelocked) {
                  this.errormessage = "车签已锁定，请先解锁";
                  return;
                } else {
                  //车签号
                  if (scanAreaContent != this.inputModel.input_CarLabel) {
                    this.PackageNumInCar = 0;
                    this.statisticalList[1].value =
                      this.PackageNumInCar.toString();
                  }
                  if (scanAreaContent.length == 20) {
                    this.errormessage = "系统生成的车签，不允许人工录入";
                    return;
                  }

                  if (scanAreaContent.startsWith("CQ")) {
                    debugger;
                    let response = CarContainerStatus(
                      scanAreaContent,
                      SystemConfigModule.globalData.LocalMac,
                      SystemConfigModule.globalData.CurrentDeviceType.toString()
                    );
                    LogHelper.Console(response);
                    if (response.status != "1") {
                      this.errormessage = response.resMsg;
                      return;
                    }
                  }
                  //车签号
                  this.setCarLabel(scanAreaContent, cpCode);
                  this.statisticalList[2].value = "0";
                  this.carCode = scanAreaContent;
                  this.inputModel.input_PanelLine = "";
                  this.inputModel.input_NextWebPoint = "";
                  this.inputModel.input_PanelLineName = "";
                  this.showDataModel.orgModels = [];
                  this.inputModel.input_NextorgSelect = "";
                  this.inputModel.input_ScanCode = "";

                  this.inputModel.input_StartSoundPlay = false;
                  this.inputModel.warehouseFlagVisible = true;
                  this.inputModel.soundPlayDisable = true;

                  //根据车签带出线路相关信息
                  var response = this.GetCQInfoByCode(scanAreaContent);
                  if (response == null || response.isSuccess == false) {
                    LogHelper.WriteLog(
                      "车签查询失败, 错误信息:" +
                        response?.respMessage +
                        "，错误代码：" +
                        response?.respcode
                    );
                    return;
                  }
                  this.createTimeCQ = response.data?.createTimeCQ;
                  this.GetCarNumInfoByCQ(scanAreaContent);
                  this.panel_line_ValueChanged(
                    response.data == null ||
                      response.data.lineCode == null ||
                      response.data.lineCode.length < 1
                      ? ""
                      : response.data.lineCode,
                    ""
                  );
                  if (!bIsCpCode && this.invalidCpCode) {
                    this.invalidCpCode = "";
                  }
                  this.CreateCarCodeMainRecord();

                  try {
                    playSuccessSound();
                  } catch (Exception) {
                    this.errormessage = "成功提示音不存在";
                  }
                  return;
                }
              }

              if (!this.CheckMainData()) {
                return;
              }
              if (!this.NewCheckWanted(scanAreaContent))
              {
                return;
              }

              //实物条码
              this.inputModel.input_PacketCode = scanAreaContent;

              let strCode = scanAreaContent;
              if (
                this.inputModel.input_ScanCode
                  .toUpperCase()
                  .startsWith("R02T") ||
                this.inputModel.input_ScanCode.toUpperCase().startsWith("R02Z")
              ) {
                strCode = this.inputModel.input_ScanCode
                  .toUpperCase()
                  .replace("R02T", "")
                  .replace("R02Z", "");
              }

              let bIsBagCode = false;
              if (rg.Type == ApiQueryType.strPackageCode) {
                this.expType = 20;
                bIsBagCode = true;
                if (this.inputModel.checked_IsCheckBagWeight) {
                  let dWeight = obj_Weight_Core.getWeight(scanAreaContent);
                  if (!this.CheckWeight(dWeight, scanAreaContent)) {
                    return;
                  }
                }
              }else
              {
                this.expType = 10;
              }
              let stPackageData = {
                code: scanAreaContent,
                height: "0",
                length: "0",
                mac: "",
                weight: "0",
                width: "0",
                DataType: "",
                CarSignNum: this.inputModel.input_CarLabel,
                NextWebPoint: this.inputModel.input_NextorgSelect,
                RecvType: this.inputModel.input_RecvType,
                optArea: "",
              };
              this.FacadeEnqueue(stPackageData, bIsBagCode);
              this.inputModel.input_ScanCode = "";
              return;
            } else {
              LogHelper.WriteLog(
                "输入条码非法，条码：" +
                  scanAreaContent +
                  "返回条码类型为：" +
                  rg.Type
              );
              this.errormessage = rg.Info + "单号：" + scanAreaContent;
              return;
            }
          }
        }

        let stCodeCheckInput: any = {
          devMac: SystemConfigModule.globalData.LocalMac,
          devType: "0",
          body: {
            queryValue: scanAreaContent,
            queryType: "0",
            viewType: "1",
            extend1: "",
            extend2: "",
            extend3: "",
          },
        };
        let stReturnData: any = {};
        //先本地
        stReturnData = RuleCheck.CheckCode(stCodeCheckInput);

        this.errormessage = stReturnData.respMessage;

        if (stReturnData.respcode != "000") {
          try {
            playFailSound();
          } catch (Exception) {
            this.errormessage = "失败提示音不存在";
          }

          bReturnState = false;
          if (stReturnData.respMessage == "") {
            this.errormessage = "服务器掉线";
          }

          this.errormessage = stReturnData.respMessage;
        } else {
          if (stReturnData.data.queryNoType == ApiQueryType.strStationCode) {
            if (false) {
            } else {
              var g = this.showDataModel.orgModels.filter((a) => {
                a.ID == stReturnData.data.queryNo;
              });
              if (g != null) {
                this.inputModel.input_NextorgSelect = g[0].Name;
                this.inputModel.input_NextWebPoint = g[0].ID;
                this.afterSelectNextWebPoint(g[0].OrgType);
              } else {
                if (this.routeNextOrgCode == "1") {
                  let response = this.NextWebPoint_KeyPress(
                    stReturnData.data.queryNo
                  );
                  let code_Check_Return_Data = JSON.parse(response);
                  if (code_Check_Return_Data.respcode == "000") {
                    this.inputModel.input_NextorgSelect =
                      code_Check_Return_Data.data.nextOrgCodeName;
                    this.inputModel.input_NextWebPoint =
                      stReturnData.data.queryNo;
                  } else {
                    this.errormessage = "未查询到网点信息";
                  }
                } else {
                  this.errormessage = "输入网点不在线路上";
                }
              }
            }
          } else if (
            stReturnData.data.queryNoType == ApiQueryType.strLineCode
          ) {
            //对应的线路框里，线路批次，下一网点ChecklineFrequencys(Code_Check_Input stCodeCheckInput, Return_Common stReturn)

            stCodeCheckInput.body.queryType = "1";
            // let stReturnTempStr = checklineFrequencys(
            //   JSON.stringify(stCodeCheckInput)
            // );
            // let stReturnTemp = JSON.parse(stReturnTempStr);
            this.errormessage = stReturnData.respMessage;
            // if (stReturnTemp == null || stReturnTemp.respcode != "000") {
              // try {
              //   // // ToolsPlayVoice.CreateSingleInstance().PlayAsycSound(strOperFailVoice);
              //   playFailSound();
              // } catch (Exception) {
              //   this.errormessage = "失败提示音不存在";
              // }

              // bReturnState = false;
              // this.errormessage = stReturnTemp.respMessage;

              // LogHelper.WriteLog("ScnForGetOn:" + stReturnTempStr);
            // } else {
              try {
                playSuccessSound();
              } catch (Exception) {
                this.errormessage = "成功提示音不存在";
              }

              this.panel_line_ValueChanged(
                stReturnData.data.queryNo,""
              );

               this.CreateCarCodeMainRecord();
            // }
          }
        }

        if (bReturnState) {
          this.inputModel.input_ScanCode = "";
        }
      } catch (ex) {
        LogHelper.WriteLog("ScnForGetOn: tbx_scanArea_KeyPress()" + ex);
      }
    } catch (error) {
      console.log("扫码流程出现错误:" + error);
    }
    this.$nextTick(() => {
      var el = document.getElementById("input_scancode_id");
      this.selectElementContents(el);
    });
  }

  /// 新增：界面根据网点代码查询网点的功能，与下车页面相同
  private NextWebPoint_KeyPress(value) {
    debugger;
    if (value.Length < 10) {
      let stCodeCheckInput: any = {};
      let stReturnData: any = {};
      stCodeCheckInput.devMac = SystemConfigModule.globalData.LocalMac;
      stCodeCheckInput.devType = "0";
      stCodeCheckInput.body.queryValue = value;
      stCodeCheckInput.body.queryType = "0";
      stCodeCheckInput.body.viewType = "1";
      stCodeCheckInput.body.extend1 = "";
      stCodeCheckInput.body.extend2 = "";
      stCodeCheckInput.body.extend3 = "";
      //先本地
      stReturnData = RuleCheck.CheckCode(stCodeCheckInput);
      if (stReturnData.respcode != "000") {
        this.errormessage = stReturnData.respMessage;
      } else if (stReturnData.data.queryNoType == ApiQueryType.strStationCode) {
        return JSON.stringify(stReturnData);
        //SetNextWebPointValue(stReturnData.data.queryNo);
        //SetNextWebPointNameValue(stReturnData.data.nextOrgCodeName);
      }
    }
    return "";
  }
  private SetPackageQueueModel(query, bIsBagCode = false) {
    debugger;
    if (query.code.toUpperCase().startsWith("R02T")) {
      let has = this.dicIoTypeForGetOn.filter((item) => {
        return item.key === "退回";
      });
      if (has.length > 0) {
        query.RecvType = has[0].value;
      } else {
        let has = this.dicIoTypeForGetOn.filter((item) => {
          return item.key === this.inputModel.input_RecvType;
        });
        query.RecvType = has[0].value;
      }
    } else if (query.code.toUpperCase().startsWith("R02Z")) {
      let has = this.dicIoTypeForGetOn.filter((item) => {
        return item.key === "更址";
      });
      if (has.length > 0) {
        query.RecvType = has[0].value;
      } else {
        let has = this.dicIoTypeForGetOn.filter((item) => {
          return item.key === this.inputModel.input_RecvType;
        });
        query.RecvType = has[0].value;
      }
    } else {
      let has = this.dicIoTypeForGetOn.filter((item) => {
        return item.key === this.inputModel.input_RecvType;
      });
      query.RecvType = has[0].value;
    }
    debugger;
    let datetimeNow = new Date().valueOf();

    //比较网关返回时间跟本地时间，如果相差20秒以上，则以网关返回时间为准，否则以本地时间为准，add by klm 2022-8-18
    let ret = this.codeAndServiceTime.filter(
      (item) => item.code == query.code
    );

    if (ret.length > 0)
    {
      let serverTime = new Date(ret[0].serviceTime);
      if (Math.abs((serverTime.getTime() - datetimeNow))/1000 > 20)
      {
        datetimeNow = serverTime.getTime();
      }
    }
    //***************************************************************************************/

    let datetime = dayjs();
    this.tableIndex++;
    let queueGetOnEntity = {
      index: this.tableIndex,
      Info: "",
      CarSignNum: query.CarSignNum,
      cbxFee: query.cbxFee,
      code: query.code,
      DataType: query.DataType,
      EffectiveTypeCode: query.EffectiveTypeCode,
      height: query.height,
      length: query.length,
      mac: query.mac,
      NextWebPoint: query.NextWebPoint,
      PreviousWebPoint: query.PreviousWebPoint,
      PutinWeight: query.PutinWeight,
      RecvType: query.RecvType,
      Str10: query.Str10,
      Str9: query.Str9,
      VolumnWeight: query.VolumnWeight,
      weight: query.weight,
      width: query.width,
      createTime: datetimeNow,
      modifyTime: datetimeNow,
      uploadTime: datetimeNow,
      ScanTime: datetime,
      Line: this.inputModel.input_PanelLineName,
      IsPackage: bIsBagCode,
      optArea: query.optArea,
      UploadStateCode: UploadStateEnum.NotStarted,
      UploadStateName: "未上传",
    };

    return queueGetOnEntity;
  }
  private GetDataUploadRequest(package_Data) {
    let stGetOnData: any = {};
    try {
      console.log(SystemConfigModule.globalData);
      //后续与对应填写，现无法获取数据
      stGetOnData.devMac = SystemConfigModule.globalData.LocalMac;
      stGetOnData.devType = "0";

      let _body: any = {};
      _body.mac = SystemConfigModule.globalData.LocalMacIPv4;
      _body.aviType = 0;
      _body.trace = 0;
      _body.isFirstTransfer = 1;
      _body.mty = "0140";
      stGetOnData.body = _body;

      let _opRecord: any = {};
      _opRecord.auxOpCode = "NEW";
      _opRecord.auxRouteCode = "";
      _opRecord.containerNo = this.inputModel.input_CarLabel;
      _opRecord.createOrgCode = SystemConfigModule.loginData.orgCode;
      _opRecord.createTerminal = SystemConfigModule.globalData.LocalIPv4;
      _opRecord.createTime = package_Data.createTime; //(DateTime.Now.ToUniversalTime().Ticks - 621355968000000000) / 10000;
      _opRecord.createUserCode = SystemConfigModule.loginData.userCode;
      _opRecord.createUserName = SystemConfigModule.loginData.employeeName;
      _opRecord.desOrgCode = this.inputModel.input_NextWebPoint;
      _opRecord.deviceType = SystemConfigModule.globalData.CurrentDeviceType.toString();
      _opRecord.expType = 10;
      _opRecord.expressContentCode = "PKG";
      _opRecord.feeAmt = "";
      _opRecord.feeFlag = 0;
      _opRecord.frequencyNo = "";
      _opRecord.inOutFlag = SystemConfigModule.globalData.InOutFlag;
      _opRecord.inputWeight = "0.0";
      _opRecord.ioType =
        package_Data.RecvType; /*"0" + (cbx_recvType.SelectedIndex + 1).ToString()*/
      /* dicIoTypeForGetOn[SCANOBJECT.input_RecvType]*/ //"01";
      //stGetOnData.body.opRecord.waybillNo = package_Data.code;  //"790000000545789";
      _opRecord.waybillNo = package_Data.code;
      _opRecord.modifyOrgCode = SystemConfigModule.loginData.orgCode;
      _opRecord.modifyTerminal = "";
      _opRecord.modifyTime = package_Data.modifyTime; //(DateTime.Now.ToUniversalTime().Ticks - 621355968000000000) / 10000;
      _opRecord.modifyUserCode = "";
      _opRecord.modifyUserName = "";
      _opRecord.nextOrgCode = this.inputModel.input_NextWebPoint; //"210901";
      _opRecord.opCode = 131;
      _opRecord.orgCode = SystemConfigModule.loginData.orgCode;
      _opRecord.uploadTime = package_Data.uploadTime; //(DateTime.Now.ToUniversalTime().Ticks - 621355968000000000) / 10000;
      _opRecord.transportTypeCode = "";
      _opRecord.transferStatus = 0;
      _opRecord.remark = "GetOn";
      _opRecord.sourceOrgCode = SystemConfigModule.loginData.orgCode;
      _opRecord.weighWeight = "0.0";
      _opRecord.pkgWidth = package_Data.width;
      _opRecord.pkgLength = package_Data.length;
      _opRecord.pkgHeight = package_Data.height;
      _opRecord.volumeWeight = "0";
      _opRecord.pkgQty = 1;
      _opRecord.lineNo = this.inputModel.input_PanelLine; //"104829";
      _opRecord.previousOrgCode = "";
      _opRecord.routeCode = "";
      stGetOnData.body.opRecord = _opRecord;

      let _customData: any = {};
      _customData.inOutDiff = "1";
      _customData.lineFrequencyNo = null; // "";
      if (ScanforGetOnModule.checked_IsOverTimeCar) {
        _customData.otFlag = 1;
      } else {
        _customData.otFlag = 0;
      }
      _customData.refId = "";
      _customData.returnPart = "";
      _customData.vehiclePlateNo = "";
      //                 if (SCANOBJECT.checked_NeedWeight)
      //                 {
      //                     stGetOnData.body.opRecord.customData.neeWeight = "1";
      //                 }
      //                 else
      //                 {
      //                     stGetOnData.body.opRecord.customData.neeWeight = "0";
      //                 }
      _customData.extend1 = SystemConfigModule.globalData.MonitorLoginStatus ? "1" : "0";
      _customData.extend2 = "0";
      if (ScanforGetOnModule.checked_NeedWeight) {
        _customData.extend2 += ",1";
      } else {
        _customData.extend2 += ",0";
      }
      _customData.optArea = package_Data.optArea;
      stGetOnData.body.opRecord.customData = _customData;
    } catch (ex) {
      LogHelper.WriteLog("ScanForGetOn-GetDataUploadRequest-Exception： " + ex);
    }

    return stGetOnData;
  }
  private NewGetDataUploadRequest(package_Data) {
    let stGetOnData: any = {};
    try {
      let _opRecord: any = {};
      _opRecord.auxOpCode = "NEW";
      _opRecord.containerNo = this.inputModel.input_CarLabel;
      _opRecord.createOrgCode = SystemConfigModule.loginData.orgCode;
      _opRecord.createTerminal =  SystemConfigModule.globalData.LocalIPv4;
      _opRecord.createTime = package_Data.createTime;
      _opRecord.createUserCode = SystemConfigModule.loginData.userCode;
      _opRecord.createUserName = this.routeNextOrgCode == "1" ? SystemConfigModule.loginData.employeeName+"-0100":SystemConfigModule.loginData.employeeName;
      _opRecord.desOrgCode = this.inputModel.input_NextWebPoint;
      _opRecord.deviceType = SystemConfigModule.globalData.CurrentDeviceType.toString();
      _opRecord.expType = this.expType;
      _opRecord.inOutFlag = SystemConfigModule.globalData.InOutFlag;
      _opRecord.ioType =
        package_Data.RecvType;
      _opRecord.waybillNo = package_Data.code;
      _opRecord.modifyOrgCode = SystemConfigModule.loginData.orgCode;
      _opRecord.modifyTime = package_Data.modifyTime;
      _opRecord.nextOrgCode = this.inputModel.input_NextWebPoint;
      _opRecord.opCode = 131;
      _opRecord.orgCode = SystemConfigModule.loginData.orgCode;
      _opRecord.uploadTime = package_Data.uploadTime;
      _opRecord.remark = "GetOn";
      _opRecord.sourceOrgCode = SystemConfigModule.loginData.orgCode;
      _opRecord.pkgWidth = package_Data.width;
      _opRecord.pkgLength = package_Data.length;
      _opRecord.pkgHeight = package_Data.height;
      _opRecord.pkgQty = 1;
      _opRecord.lineNo = this.inputModel.input_PanelLine; //"104829";
      _opRecord.warehouseFlag = this.inputModel.input_StartSoundPlay ? "1" : "0";
      _opRecord.warehouseNo = !this.inputModel.input_warehouseFlag ? 0 : Number(this.inputModel.input_warehouseFlag);
      _opRecord.createTimeCQ = this.createTimeCQ;

      let _body: any = {};
      _body.opRecord = _opRecord;
      _body.isFirstTransfer = 1;
      stGetOnData.body = _body;

      let _customData: any = {};
      if (ScanforGetOnModule.checked_IsOverTimeCar) {
        _customData.otFlag = 1;
      } else {
        _customData.otFlag = 0;
      }
      _customData.extend1 = SystemConfigModule.globalData.MonitorLoginStatus ? "1" : "0";
      _customData.extend2 = "0";
      if (ScanforGetOnModule.checked_NeedWeight) {
        _customData.extend2 += ",1";
      } else {
        _customData.extend2 += ",0";
      }
      _customData.optArea = package_Data.optArea;
      stGetOnData.body.opRecord.customData = _customData;
    } catch (ex) {
      LogHelper.WriteLog("ScanForGetOn-GetDataUploadRequest-Exception： " + ex);
    }

    return stGetOnData;
  }
  public CreateCarSignNumberMainRecord(carCode)
  {
    // if (CarSignNumFlag[OpCodeEnum.aboard] != (((JObject)request["body"])["opRecord"])["containerNo"].ToString()){
    //   //创建车签主记录
    //   var requestMain = common.DataConvertHelper.DeepClone(request);
    //   requestMain["body"]["opRecord"]["waybillNo"] = (((JObject)request["body"])["opRecord"])["containerNo"].ToString();
    //   requestMain["body"]["opRecord"]["opCode"] = "130";
    //   requestMain["body"]["opRecord"]["expType"] = "40";
    //   CarSignNumFlag[OpCodeEnum.aboard] = (((JObject)request["body"])["opRecord"])["containerNo"].ToString();
    //   isDetail = false;
    //   var interfaceResponse = new HttpTransport.HttpFacade().NewGetOn(requestMain);
    // }
debugger;
    let stGetOnData: any = {};
    try {
      let _opRecord: any = {};
      _opRecord.auxOpCode = "NEW";
      _opRecord.containerNo = carCode;
      _opRecord.createOrgCode = SystemConfigModule.loginData.orgCode;
      _opRecord.createTerminal =  SystemConfigModule.globalData.LocalIPv4;
      _opRecord.createTime = dayjs().valueOf();
      _opRecord.createUserCode = SystemConfigModule.loginData.userCode;
      _opRecord.createUserName = this.routeNextOrgCode == "1" ? SystemConfigModule.loginData.employeeName+"-0100":SystemConfigModule.loginData.employeeName;
      _opRecord.desOrgCode = this.inputModel.input_NextWebPoint;
      _opRecord.deviceType = SystemConfigModule.globalData.CurrentDeviceType.toString();
      _opRecord.expType = 40;
      _opRecord.inOutFlag = SystemConfigModule.globalData.InOutFlag;
      console.log(this.inputModel.input_RecvType);
      let has = this.dicIoTypeForGetOn.filter((item) => {
        return item.key === this.inputModel.input_RecvType;
      });
      if (has.length > 0) {
        _opRecord.ioType = has[0].value;
      }else{
        _opRecord.ioType = "01";
      }
      _opRecord.waybillNo = carCode;
      _opRecord.modifyOrgCode = SystemConfigModule.loginData.orgCode;
      _opRecord.modifyTime = dayjs().valueOf();
      _opRecord.nextOrgCode = this.inputModel.input_NextWebPoint;
      _opRecord.opCode = 130;
      _opRecord.orgCode = SystemConfigModule.loginData.orgCode;
      _opRecord.uploadTime = dayjs().valueOf();
      _opRecord.remark = "GetOn";
      _opRecord.sourceOrgCode = SystemConfigModule.loginData.orgCode;
      _opRecord.pkgWidth = "";
      _opRecord.pkgLength = "";
      _opRecord.pkgHeight = "";
      _opRecord.pkgQty = 1;
      _opRecord.lineNo = this.inputModel.input_PanelLine; //"MOT210045TO02104401";
      const invalidCpCode = this.invalidCpCode;
      if (this.invalidCpCode) {
        this.invalidCpCode = "";
      }
      // 暂时注释掉
      // if (this.cpCode) {
      //   _opRecord.cpNo = this.cpCode
      // } if (invalidCpCode) {
      //   _opRecord.supplementCpFlag = "1";
      //   _opRecord.cpNo = invalidCpCode;
      // }


      let _body: any = {};
      _body.opRecord = _opRecord;
      _body.isFirstTransfer = 1;
      stGetOnData.body = _body;

      let _customData: any = {};
      if (ScanforGetOnModule.checked_IsOverTimeCar) {
        _customData.otFlag = 1;
      } else {
        _customData.otFlag = 0;
      }
      _customData.extend1 = SystemConfigModule.globalData.MonitorLoginStatus ? "1" : "0";
      _customData.extend2 = "0";
      if (ScanforGetOnModule.checked_NeedWeight) {
        _customData.extend2 += ",1";
      } else {
        _customData.extend2 += ",0";
      }
      _customData.optArea = "";
      stGetOnData.body.opRecord.customData = _customData;
    } catch (ex) {
      LogHelper.WriteLog("ScanForGetOn-GetDataUploadRequest-Exception： " + ex);
    }
    let result = JSON.parse(abord(JSON.stringify(stGetOnData)));
    console.log(result);
    return result;
  }

  public FacadeEnqueue(stPackageData, bIsBagCode: boolean) {
    console.log("stPackageData");
    debugger;
    console.log(stPackageData);
    //获取实体
    let package_DataByQueue = this.SetPackageQueueModel(
      stPackageData,
      bIsBagCode
    );
    if (obj_Camera_Core.cameraBLLEnqueueFacadeNew != undefined)
    {
      let resultStr = obj_Camera_Core.cameraBLLEnqueueFacadeNew(
        stPackageData.code,
        OpCodeEnum.aboard,
        SystemConfigModule.loginData.employeeName,
        this.inputModel.input_NextWebPoint,
        "上车",
        parseTime(new Date(package_DataByQueue.createTime)),
        package_DataByQueue.Str9?package_DataByQueue.Str9:"无格口"
      );
    }
    else
    {
      let resultStr = obj_Camera_Core.cameraBLLEnqueueFacade(
        stPackageData.code,
        OpCodeEnum.aboard,
        SystemConfigModule.loginData.employeeName,
        this.inputModel.input_NextWebPoint,
        "上车"
      );
    }
   //let request = this.GetDataUploadRequest(package_DataByQueue);
   debugger
    let request = this.NewGetDataUploadRequest(package_DataByQueue);
    let ExpWayBillCheckQueueEntity = {
      CallBack: null,
      Id: dayjs().valueOf().toString(), //交给C#实现
      Request: request,
      WaybillNo: package_DataByQueue.code,
      devType: SystemConfigModule.globalData.CurrentDeviceType.toString(),
      bIsPackageCode: bIsBagCode,
      latticeNo: "",
      destOrgCode: "",
      sourceOrgCode: "",
      OpCode: OpCodeEnum.aboard,
      daTouBi: null,
      protocolType:0//当前协议类型，1表示供件协议，0表示正常协议，默认为正常协议
    };
    //插入队列
    // obj_HttpRequest_Core.enqueueFacade(
    //   this.DataUploadCallBack,
    //   JSON.stringify(request),
    //   // JSON.stringify(package_DataByQueue),
    //   JSON.stringify(ExpWayBillCheckQueueEntity)
    // );

    this.EnqueueFacade(ExpWayBillCheckQueueEntity);

    // // YTO.Automation.Business.ExpWayBillCheckBLL.EnqueueFacade(new ExpWayBillCheckQueueEntity()
    // // {
    // //     CallBack = DataUploadCallBack,
    // //     Id = Guid.NewGuid().ToString(),
    // //     Request = GetDataUploadRequest(package_DataByQueue),
    // //     WaybillNo = package_DataByQueue.code,
    // //     devType = nMode.ToString(),
    // //     bIsPackageCode = bIsBagCode,
    // //     latticeNo = "",
    // //     destOrgCode = "",
    // //     sourceOrgCode = "",
    // //     OpCode = YTO.Automation.Model.HttpModel.OpCodeEnum.aboard
    // // });

    //             if (package_DataByQueue.code.ToUpper().StartsWith("R02T") ||
    //                 package_DataByQueue.code.ToUpper().StartsWith("R02Z"))
    //             {
    //                 package_DataByQueue.code = package_DataByQueue.code.ToUpper().Replace("R02T", "").Replace("R02Z", "");
    //             }

    /*if (DataHistory.Any(x => x.code == package_DataByQueue.code))
            {
                label_scanReturnError = "重复扫码";
                return;
            }*/
    if (package_DataByQueue.code.startsWith("R02T")) {
      let has = this.dicIoTypeForGetOn.some((item) => {
        return item.key === "退回";
      });
      if (has) {
        package_DataByQueue.RecvType = "退回";
      } else {
        package_DataByQueue.RecvType = this.inputModel.input_RecvType;
      }
      package_DataByQueue.code = package_DataByQueue.code
        .toUpperCase()
        .replace("R02T", "")
        .replace("R02Z", "");
    } else if (package_DataByQueue.code.startsWith("R02Z")) {
      let has = this.dicIoTypeForGetOn.some((item) => {
        return item.key === "更址";
      });
      if (has) {
        package_DataByQueue.RecvType = "更址";
      } else {
        package_DataByQueue.RecvType = this.inputModel.input_RecvType;
      }
      package_DataByQueue.code = package_DataByQueue.code
        .toUpperCase()
        .replace("R02T", "")
        .replace("R02Z", "");
    } else {
      package_DataByQueue.RecvType = this.inputModel.input_RecvType;
    }
    //插入列表集合，并更新列表控件
    this.InsertDataToList(package_DataByQueue);
    // PlaySuccessSound();
    //playSuccessSound();
    if (!this.inputModel.checked_RecvTypeLock) {
      this.inputModel.input_RecvType = "正常";
    }
    //黄埔仓模式上车优化
    if (this.routeNextOrgCode == "1") {
      if (this.inputModel.checked_AutoCreateCarCode) {
        this.setCarLabel("");
      }
      this.inputModel.input_NextorgSelect = "";
      this.inputModel.input_NextWebPoint = "";
    }
    //更新汇总信息
    this.nTotalScanNum++;
    this.statisticalList[0].value = this.nTotalScanNum.toString();
    this.PackageNumInCar++;
    this.statisticalList[1].value = this.PackageNumInCar.toString();
  }
  public tableIndex = 0;
  public InsertDataToList(package_DataByQueue) {
    let datetime = package_DataByQueue.ScanTime;
    let datetimeStr = datetime.format("YYYY-MM-DD HH:mm:ss");
    package_DataByQueue.ScanTime = datetimeStr;
    this.showList.unshift(package_DataByQueue);
    while (this.showList.length > 50) {
      this.showList.pop();
    }
  }
  public DataUploadCallBack(callbackentityStr) {
    debugger;
    let callbackentity;
    try {
      if (callbackentityStr != null && callbackentityStr.length < 1) {
        return;
      }
      callbackentity = JSON.parse(callbackentityStr);
    } catch (error) {
      callbackentity = null;
    }

    if (callbackentity == null || callbackentity.Response == null) {
      return;
    } else {
      if (callbackentity.extend1 == "1") {
        this.PackageNumInCar = 1;
        this.statisticalList[1].value = this.PackageNumInCar.toString();
      }

      if (
        callbackentity.IsSuccess ||
        (callbackentity.IsSuccess == false && (callbackentity.extend1 == "2" || callbackentity.extend1 == "3"))
      ) {
        // nGetOnOnlyFailCount = 0;
      } else {
        this.NoticePlcMsg(this.stopCmd);
        // nGetOnOnlyFailCount++;
      }

      let stReturn = callbackentity.Response;
      let strCode = callbackentity.Request.WaybillNo;

      if (
        strCode.toUpperCase().startsWith("R02T") ||
        strCode.toUpperCase().startsWith("R02Z")
      ) {
        strCode = strCode.toUpperCase().replace("R02T", "").replace("R02Z", "");
      }

      let first: any = this.showList.filter(
        (element) => element.code == strCode
      );
      if (first != null && first.length > 0) {
        if (
          !(
            stReturn?.data?.opRecord?.PDA_NO == null ||
            stReturn?.data?.opRecord?.PDA_NO.length < 1
          )
        ) {
          first[0].NextWebPoint = stReturn.data.opRecord.PDA_NO;
        }
        first[0].UploadStateCode = callbackentity.IsSuccess
          ? UploadStateEnum.Sucess
          : UploadStateEnum.Fail;
        first[0].UploadStateName = callbackentity.IsSuccess
          ? "上传成功"
          : "上传失败";

        let _checkWantedCodeResult = this.checkWantedCode.filter(
          (element) => element.key == strCode
        );
        if (_checkWantedCodeResult.length > 0) {
          first[0].Info = _checkWantedCodeResult[0].value;
        } else {
          first[0].Info = stReturn?.respMessage;
        }
        //新增:如果是黄埔仓模式 且 自动生成车签的标识 选中
        //add 2021年9月3日11:41:26  顾杨
        if (
          this.routeNextOrgCode === "1" &&
          this.inputModel.checked_AutoCreateCarCode
        ) {
          //界面显示的 车签和下一网点 采用网关返回的值
          first[0].CarSignNum = stReturn?.data.opRecord.containerNo; //YT2600191827105

          if (
            stReturn?.data.opRecord.nextOrgCode != null &&
            stReturn?.data.opRecord.nextOrgCode.Length > 0
          ) {
            if (
              stReturn?.data.opRecord.nextOrgCode != null &&
              stReturn?.data.opRecord.nextOrgCode.length >= 10
            ) {
              let stCodeCheckInput: any = {
                devMac: SystemConfigModule.globalData.LocalMac,
                devType: "0",
                body: {
                  queryValue: stReturn?.data.opRecord.nextOrgCode.toUpperCase(),
                  queryType: "0",
                  viewType: "1",
                  extend1: "",
                  extend2: "",
                  extend3: "",
                },
              };
              //先本地
              let responseStr = RuleCheck.CheckCode(stCodeCheckInput);
              let code_Check_Return_Data = JSON.parse(responseStr);
              if (code_Check_Return_Data.respcode == "000") {
                first[0].NextWebPoint =
                  code_Check_Return_Data.data.nextOrgCodeName;
              } else {
                first[0].NextWebPoint = stReturn?.data.opRecord.nextOrgCode;
              }
            }
          }
        }
      }
      this.ClearData();
    }
  }

  public CheckWeight(weight, code) {
    if (weight == -1 || weight == -2) {
      this.errormessage = "还未连接电子秤，请关闭包重量\r\n复核哦";
      return false;
    } else {
      //包件重量复核
      let result = this.CheckAgainForPackage("110", code);
      let packageWeight = 0;
      if (result == null || result.length < 1) {
        console.log(code.toString()+"未查询到重量，跳过校验");
        return true;
      } else {
        packageWeight = Number.parseFloat(result);
      }
      let tmp = packageWeight - weight;
      if (tmp < 0) {
        tmp = tmp * -1;
      }

      let alw = 0;
      if (
        this.inputModel.input_TempWeight == null ||
        this.inputModel.input_TempWeight.trim().length < 1
      ) {
        console.log(code.toString()+"差异参数为空，跳过校验");
        return true;
      } else {
        alw = Number.parseFloat(this.inputModel.input_TempWeight.trim());
      }

      if (tmp > alw) {
        this.errormessage = "重量差异 " + tmp + " KG，请核实";
        return false;
      }
    }
    return true;
  }

  //原有的异常走件接口，废弃, 不再调用，modify by klm 20220420
  public AbnormalMovingPartUpload(
    strCode,
    strInfo,
    strIoTypeName = null,
    exceptionCode = null
  ) {
    try {
      var request = this.GetAbnormalMovingPartUploadRequest(
        strCode,
        strInfo,
        strIoTypeName,
        exceptionCode
      );
      let responseStr = abnormalMovingPartDataUpload(JSON.stringify(request));
      let response = JSON.parse(responseStr);
      if (!response.isSuccess) {
        LogHelper.WriteLog("异常走件上传失败" + response.respMessage);
      } else {
        LogHelper.WriteLog("异常走件上传成功" + response.respMessage);
      }
    } catch (ex) {
      LogHelper.WriteLog("异常走件方法调用异常" + ex);
    }
  }

  //新异常走件接口，add by klm 20220420
  public NewAbnormalMovingPartUpload(
    strCode,
    strInfo,
    strIoTypeName = null,
    exceptionCode = null)
  {
    try {
      let ioType = null;
      try {
        if (strCode.startsWith("R02T")) {
          let has = this.dicIoTypeForGetOn.filter((item) => {
            return item.key === "退回";
          });

          if (has.length > 0) {
            ioType = has[0].value;
          }
        } else if (strCode.startsWith("R02Z")) {
          let has = this.dicIoTypeForGetOn.filter((item) => {
            return item.key === "更址";
          });

          if (has.length > 0) {
            ioType = has[0].value;
          }
        } else {
          if (
            (strIoTypeName == null || strIoTypeName.length < 1) &&
            this.dicIoTypeForGetOn.some((item) => {
              return item.key === strIoTypeName;
            })
          ) {
            let has = this.dicIoTypeForGetOn.filter((item) => {
              return item.key === strIoTypeName;
            });

            ioType = has[0].value;
          }
        }
        strCode = strCode.toUpperCase().replace("R02T", "").replace("R02Z", "");
      } catch (ex) {
        LogHelper.WriteLog(
          "上车，异常走件接口GetAbnormalMovingPartUploadRequest处理失败" + ex
        );
      }
      let datetimeNow = dayjs().format("YYYY-MM-DD HH:mm:ss.SSS");
      let signsure = obj_HttpRequest_Core.getSignature("8606", datetimeNow);

      let _request = {
        mty:"8606",
        signature: signsure,//登录时需要获取的签名
        createTime: datetimeNow,
        waybillNo: strCode,
        containerNo: this.inputModel.input_CarLabel,//容器号,非必填
        deviceType: SystemConfigModule.globalData.CurrentDeviceType.toString(),//设备类型，必填
        deviceNo: SystemConfigModule.globalData.LocalIPv4,//大写,用冒号分隔，必填
        errorCode: exceptionCode,//异常码，必填
        errorMsg: strInfo,//异常信息，必填
        opCode: "131",//操作码，非必填
        ioType:ioType,//收发类型，非必填
        nextOrgCode:"",//下一网点，非必填
        weight:"",//重量，非必填
        createUserCode:SystemConfigModule.loginData.userCode,
        extend1:"",
        extend2:"",
        extend3:""
      };
      let stReturnStr = JSON.parse(cloudPress(JSON.stringify(_request)));
      if (stReturnStr?.code == "000")
      {
        LogHelper.WriteLog("新异常走件方法上传成功");
      }
      else
      {
        LogHelper.WriteLog("新异常走件上传失败,返回异常码："+ stReturnStr?.code+"异常信息：" + stReturnStr?.msg);
      }
    }
    catch(ex)
    {
      LogHelper.WriteLog("新异常走件接口调用异常" + ex);
    }
  }

  private dicIoTypeForGetOn = [];
  private GetAbnormalMovingPartUploadRequest(
    code,
    strInfo,
    strIoTypeName = null,
    exceptionCode = null
  ) {
    let ioType = "";
    try {
      if (code.startsWith("R02T")) {
        let has = this.dicIoTypeForGetOn.filter((item) => {
          return item.key === "退回";
        });

        if (has.length > 0) {
          ioType = has[0].value;
        }
      } else if (code.startsWith("R02Z")) {
        let has = this.dicIoTypeForGetOn.filter((item) => {
          return item.key === "更址";
        });

        if (has.length > 0) {
          ioType = has[0].value;
        }
      } else {
        if (
          (strIoTypeName == null || strIoTypeName.length < 1) &&
          this.dicIoTypeForGetOn.some((item) => {
            return item.key === strIoTypeName;
          })
        ) {
          let has = this.dicIoTypeForGetOn.filter((item) => {
            return item.key === strIoTypeName;
          });

          ioType = has[0].value;
        }
      }
      code = code.toUpperCase().replace("R02T", "").replace("R02Z", "");
    } catch (ex) {
      LogHelper.WriteLog(
        "上车，异常走件接口GetAbnormalMovingPartUploadRequest处理失败" + ex
      );
    }
    let _timestamp = new Date().valueOf();
    let _request = {
      devMac: SystemConfigModule.globalData.LocalMac,
      devType: SystemConfigModule.globalData.CurrentDeviceType.toString(),
      body: {
        containerNo: this.inputModel.input_CarLabel,
        effectiveTypeCode: null,
        frequencyNo: null,
        empCode: SystemConfigModule.globalData.userCode,
        ioType: ioType == null || ioType == "" ? null : ioType,
        nextOrgCode: this.inputModel.input_NextWebPoint,
        opCode: "131",
        orgCode: SystemConfigModule.globalData.orgCode,
        createTime: _timestamp,
        previousOrgCode: null /*tbx_previousWebPoint.Text*/,
        waybillNo: code,
        weight: null,
        deviceType: strInfo,
        errorCode: exceptionCode,
        extend1: "",
        extend2: "",
        extend3: "",
      },
    };

    return _request;
  }
  public interCeptorCode = ["-101","-102","-103","-104"];
  private NewCheckWanted(scanContent) {
    let CheckWantedRequest = {
      waybillNo: scanContent,
      optFlag: "3"
      };
    let checkWantedResponseStr = newCheckWanted(
      JSON.stringify(CheckWantedRequest)
    );
    let checkWantedResponse = JSON.parse(checkWantedResponseStr);

    try
    {
      if (null != checkWantedResponse?.data.currentTime && "" != checkWantedResponse?.data.currentTime && undefined != checkWantedResponse?.data.currentTime)
      {
        this.codeAndServiceTime.unshift({code:scanContent,serviceTime:checkWantedResponse?.data.currentTime});
        if (this.codeAndServiceTime.length > this.codeCount) {
          let dd = this.codeAndServiceTime.pop();
        }
      }

      //刷新本地时间
      obj_System_Core.refreshLoaclTime(checkWantedResponse?.data.currentTime);
    }
    catch(error)
    {
      console.log(error);
    }
    debugger;
    //通缉件或者拦截件
    if (checkWantedResponse != null && checkWantedResponse?.respcode != null &&
      checkWantedResponse?.respcode != "" && checkWantedResponse.respcode.startsWith("-"))
    {
      if (this.interCeptorCode.indexOf(checkWantedResponse?.respcode) != -1)
      {
        playWantedPackSound(checkWantedResponse?.respcode);
      }
      else
      {
        playFailSound();
      }
      this.errormessage = checkWantedResponse.respMessage;
      this.checkWantedCode.unshift({
        key: scanContent,
        value: checkWantedResponse.respMessage,
      });
      while (this.checkWantedCode.length > 5) {
        this.checkWantedCode.pop();
      }
      //是否生成异常轨迹
      if (checkWantedResponse?.data.uploadErrorFlag == "1")
      {
        this.$nextTick(() => {
          this.NewAbnormalMovingPartUpload(
            scanContent,
            checkWantedResponse.respMessage,
            this.inputModel.input_RecvType,
            checkWantedResponse.respcode
          );
        });
      }
      //是否生成正常轨迹
      if (checkWantedResponse?.data.uploadOptFlag == "1")
      {
        return true;
      }
      else
      {
        return false
      }
    }
    else
    {
      return true;
    }
  }

  private m_bNoNesseryMsg = false;
  private CheckMainData() {
    let bIsError = false;
    let strPromot = "";

    //如果是黄埔仓模式 且 界面上勾选了自动生成车签
    if (
      this.routeNextOrgCode === "1" &&
      this.inputModel.checked_AutoCreateCarCode
    ) {
      //不检查车签是否为空
    } else {
      if (
        this.inputModel.input_CarLabel == null ||
        this.inputModel.input_CarLabel.length == 0
      ) {
        strPromot = "车签不能为空";
        bIsError = true;
      }
    }
    if (
      this.inputModel.input_PanelLine == null ||
      this.inputModel.input_PanelLine.length == 0
    ) {
      strPromot = "线路不能为空";
      bIsError = true;
    }
    //else if (string.IsNullOrEmpty(SCANOBJECT.input_NextWebPoint))
    //{
    //    strPromot = "下一网点不能为空";
    //    bIsError = true;
    //}
    else if (
      this.inputModel.input_RecvType == null ||
      this.inputModel.input_RecvType.length == 0
    ) {
      strPromot = "收发类型不能为空";
      bIsError = true;
    }

    if (bIsError) {
      try {
        // soundPlayer.SoundLocation = strOperFailVoice;
        // soundPlayer.Load();
        // soundPlayer.Play();
        playFailSound();
      } catch (Exception) {
        this.errormessage = "失败提示音不存在";
      }

      this.m_bNoNesseryMsg = true;
      this.errormessage = strPromot;
      return false;
    }

    this.m_bNoNesseryMsg = false;

    return true;
  }

  public LinePreFixRuleCheck(scanContent: string) {
    let flag = false;
    var rulesStr = obj_GlobalData_Core.getLineCodePreFixRules();
    if (rulesStr != null && rulesStr.length > 0) {
      var rules = JSON.parse(rulesStr);
      rules.forEach((element) => {
        console.log(element); //可遍历到所有数组元素
        if (scanContent.startsWith(element)) {
          flag = true;
        }
      });
    } else {
      this.linePrefixRuleIds.forEach((element) => {
        console.log(element); //可遍历到所有数组元素
        if (scanContent.startsWith(element)) {
          flag = true;
        }
      });
    }
    return flag;
  }
  public GetLineDetail(lineId) {
    let body = {
      queryValue: lineId, //过滤字符串
      queryType: "21",
      viewType: "1",
      extend1: "", //当前页
      extend2: "", //页大小
      extend3: "", //过滤字段
    };
    let job = {
      devMac: "00-00-00-00-00-00",
      devType: "0",
      body: body,
    };
    // let paramsJsonStr = Newtonsoft.Json.JsonConvert.SerializeObject(job);
    // let signature = Encrypt(GetLength(paramsJsonStr).ToString("00000000") + paramsJsonStr);
    let responseStr = getOrgCodeListByPage(JSON.stringify(job));
    let response = JSON.parse(responseStr);
    return response;
  }

  public panel_line_ValueChanged(id, content) {
    this.errormessage = "";
    try {
      if (id == null || id.length == 0) {
        return;
      }
      let bReturnState = true;

      let stCodeCheckInput: any = {
        devMac: SystemConfigModule.globalData.LocalMac,
        devType: "0",
        body: {
          queryValue: id.toUpperCase(),
          queryType: "0",
          viewType: "1",
          extend1: "",
          extend2: "",
          extend3: "",
        },
      };

      if (!this.NativeCheck(id)) {
        this.errormessage = "输入号码非法";
        return;
      }
      //先本地
      let stReturnData = RuleCheck.CheckCode(stCodeCheckInput);

      this.errormessage = stReturnData.respMessage;

      if (stReturnData == null || stReturnData.respcode != "000") {
        bReturnState = false;
        if (stReturnData.respMessage == "") {
          this.errormessage = "服务器掉线";
        }

        this.errormessage = stReturnData.respMessage;
      } else {
        if (stReturnData.data.queryNoType == ApiQueryType.strCarCode) {
          if (this.inputModel.checked_CarCodelocked) {
            this.errormessage = "车签已锁定，请先解锁";
          } else {
            //车签号
            this.setCarLabel(stReturnData.data.queryNo);
            this.carCode = stReturnData.data.queryNo;
            this.inputModel.input_PanelLine = "";
            this.inputModel.input_NextWebPoint = "";
            this.inputModel.input_PanelLineName = "";
            this.showDataModel.orgModels = [];
            this.inputModel.input_NextorgSelect = "";
          }
        } else if (
          stReturnData.data.queryNoType == ApiQueryType.strTimeValidCode
        ) {
        } else if (
          stReturnData.data.queryNoType == ApiQueryType.strStationCode
        ) {
          if (false) {
          } else {
            if (
              this.routeNextOrgCode === "-1" ||
              this.routeNextOrgCode === "0"
            ) {
              this.inputModel.input_NextWebPoint = stReturnData.data.queryNo;
            } else if (this.routeNextOrgCode === "1") {
              this.inputModel.input_NextWebPoint = "";
            }
          }
        } else if (stReturnData.data.queryNoType == ApiQueryType.strLineCode) {
          //对应的线路框里，线路批次，下一网点ChecklineFrequencys(Code_Check_Input stCodeCheckInput, Return_Common stReturn)
          var result = this.GetLineDetail(id);
          this.storeNextOrgs(result);
          if (result != null) {
            try {
              let job = result.data;
              let jArray = job.busiDataArray;

              this.showDataModel.FormName = "下一网点";
              this.showDataModel.orgModels = [];
              jArray.forEach((element) => {
                if (
                  element != null &&
                  element.endOrgType != null &&
                  element.endOrgType.length > 0
                ) {
                  this.showDataModel.orgModels.push({
                    ID: element.endOrgCode,
                    Name: element.endOrgName,
                    OrgType: element.endOrgType,
                  });
                } else {
                  this.showDataModel.orgModels.push({
                    ID: element.endOrgCode,
                    Name: element.endOrgName,
                  });
                }
              });

              if (
                this.routeNextOrgCode === "-1" ||
                this.routeNextOrgCode === "0"
              ) {
                if (
                  this.showDataModel != null &&
                  this.showDataModel.orgModels.length > 0
                ) {
                  this.inputModel.input_NextorgSelect =
                    this.showDataModel?.orgModels[this.showDataModel?.orgModels.length-1].Name;
                  this.inputModel.input_NextWebPoint =
                    this.showDataModel?.orgModels[this.showDataModel?.orgModels.length-1].ID;
                  this.afterSelectNextWebPoint(this.showDataModel?.orgModels[this.showDataModel?.orgModels.length-1].OrgType);
                }
                if (this.inputModel.checked_AutoCreateCarCode) {
                  if (
                    // SystemConfigModule.globalData.CurrentOrgType == "TRANSFER_CENTER" &&
                    this.showDataModel?.orgModels[this.showDataModel?.orgModels.length-1].OrgType != "转运中心"
                  ) {
                    this.carCode = this.GetAutoCarCode(
                      this.inputModel.input_NextWebPoint
                    );
                  } else {
                    this.setCarLabel("");
                  }
                } else {
                }
              } else if (this.routeNextOrgCode === "1") {
                this.inputModel.input_NextorgSelect = "";
                this.inputModel.input_NextWebPoint = "";
              }
            } catch (ex) {
              LogHelper.WriteLog("异常：" + ex);
            }
          }

          stCodeCheckInput.body.queryType = "1";
          // let stReturnTempStr = checklineFrequencys(
          //   JSON.stringify(stCodeCheckInput)
          // );
          // let stReturnTemp = JSON.parse(stReturnTempStr);
          this.errormessage = stReturnData.respMessage;
          // if (stReturnTemp == null || stReturnTemp.respcode != "000") {
          //   bReturnState = false;
          //   this.errormessage = stReturnTemp.respMessage;
          //   LogHelper.WriteLog("ScnForGetOn:" + stReturnTempStr);
          // } else {
            // if (
            //   this.routeNextOrgCode === "-1" ||
            //   this.routeNextOrgCode === "0"
            // ) {
            //   if (
            //     !(
            //       stReturnTemp.data.nextOrgCode == null ||
            //       stReturnTemp.data.nextOrgCode.length < 1
            //     )
            //   ) {
            //     this.inputModel.input_NextWebPoint =
            //       stReturnTemp.data.nextOrgCode;
            //   }
            // } else if (this.routeNextOrgCode === "1") {
            // }
            // this.inputModel.input_PanelLineName = stReturnTemp.data.extend1;
            // this.inputModel.input_PanelLine = stReturnTemp.data.queryNo;

            // this.inputModel.input_PanelLineName = stReturnTemp.data.extend1;
            // this.inputModel.input_PanelLine = stReturnTemp.data.queryNo;
            this.GetLineInfo(stReturnData.data.queryNo);
            // console.log(this.nextOrgsOption);


          // }
        }
      }

      if (bReturnState) {
        this.inputModel.input_ScanCode = "";
      }
    } catch (ex) {
      LogHelper.WriteLog("选择线路：" + ex);
    }
  }
  private GetLineInfo(lineId) {
    let request = {
      devMac: "00-00-00-00-00-00",
      devType: "0",
      body: {
        queryValue: lineId,
        queryType: "16",
        viewType: "1",
        extend1: "1",
        extend2: "10",
        extend3: "",
      },
    };

    let response = JSON.parse(getLineListByPage(JSON.stringify(request)));
    if (
      response != null &&
      response.respcode == "000" &&
      response.data.busiData.records.length > 0
    ) {
      this.inputModel.input_PanelLineName =
        response.data.busiData.records[0].lineName;
      this.inputModel.input_PanelLine = response.data.busiData.records[0].lineNo;
    } else {
      this.errormessage = "未查询到线路名称";
      this.inputModel.input_PanelLineName = "";
      this.inputModel.input_PanelLine = "";
    }
  }
  private NativeCheck(id) {
    let _result = this.LinePreFixRuleCheck(id);
    if (!_result) {
      let temps = [];
      temps.push(id);
      // var rgStr = checkCodesAndType(JSON.stringify(temps));
      var rgStr = checkCodesAndType(
        temps,
        "131",
        this.inputModel.input_CarLabel
      );
      var rg = JSON.parse(rgStr);
      if (rg != null && rg.ResultCode == "200") {
        return true;
      } else {
        return false;
      }
    }
    return _result;
  }
  public callbackmodel = {};

  //界面参数更新方法
  private scanareacallback(backdata): void {
    this.callbackmodel = backdata;
    // if (backdata.input_CarLabel.length < 20) {
    //   this.formModel2.checked_AutoCreateCarCode = false;
    // }
  }

  public deletedatahistory() {
    this.errormessage = "";
    if (this.currentrow === null) {
      this.$message.warning("请先选择要删除的行");
      return;
    }
    if (this.currentrow.UploadStateName == "未上传") {
      this.errormessage = "未上传，不能删除！";
      return;
    }
    this.$confirm("是否确定要删除此数据？", "删除", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        try {
          let nRes = this.UploadDataFromDgvToServer(this.currentrow);
          if (nRes == 0) {
            let _showlist = this.showList;
            if (_showlist != null && _showlist.length > 0) {
              let list = this.showList.filter(
                (_element) =>
                  !(
                    _element.index == this.currentrow.index &&
                    _element.code == this.currentrow.code
                  )
              );
              this.showList = list;
            }
            // DataHistory.Remove(entity);
            this.ClearData();
            this.errormessage = "删除成功！";
            LogHelper.WriteLog(
              "ScanGetOn_Delete:" +
                "Barcode " +
                this.currentrow?.code +
                " is Deleted"
            );
            if (this.nTotalScanNum > 0) this.nTotalScanNum--;
            this.statisticalList[0].value = this.nTotalScanNum.toString();
            if (this.PackageNumInCar > 0) this.PackageNumInCar--;
            this.statisticalList[1].value = this.PackageNumInCar.toString();
            this.currentrow = null;
          }
        } catch (error) {
          console.log("删除失败：" + error.message);
        }
      })
      .catch(() => {
        console.log("取消删除");
      });
  }
  //0-正常  1-异常  2-重复
  private UploadDataFromDgvToServer(entity) {
    try {
      let datetimeNow = new Date().valueOf();
      // (DateTime.Now.ToUniversalTime().Ticks - 621355968000000000) / 10000;

      let opCode = 131;
      let strauxOpCode = "DELETE";
      let stGetOnData: any = {};

      //后续与对应填写，现无法获取数据
      stGetOnData.devMac = SystemConfigModule.globalData.LocalMac;
      stGetOnData.devType = "0";

      let body: any = {};
      body.mac =SystemConfigModule.globalData.LocalMacIPv4;
      body.aviType = 0;
      body.trace = 0;
      body.isFirstTransfer = 1;
      body.mty = "0140";
      stGetOnData.body = body;

      // stGetOnData.body.opRecord = new ServerClass_GetOn();
      let opRecord: any = {};
      opRecord.auxOpCode = strauxOpCode;
      opRecord.auxRouteCode = entity.code;
      // opRecord.containerNo = entity.CarSignNum;
      opRecord.containerNo = ""; //2021年9月3日更新内容：删除时，不传车签，只传单号
      opRecord.createOrgCode = SystemConfigModule.loginData.orgCode;
      opRecord.createTerminal = SystemConfigModule.globalData.LocalIPv4;
      opRecord.createTime = datetimeNow;
      opRecord.createUserCode = SystemConfigModule.loginData.userCode;
      opRecord.createUserName = SystemConfigModule.loginData.employeeName;
      opRecord.desOrgCode = entity.NextWebPoint;

      opRecord.deviceType = SystemConfigModule.globalData.CurrentDeviceType.toString();
      opRecord.expType = 10;
      opRecord.expressContentCode = "PKG";
      opRecord.feeAmt = "";
      opRecord.feeFlag = 0;
      opRecord.frequencyNo = "FC21090104";
      opRecord.inputWeight = "0.0";
      opRecord.ioType = entity.RecvType;
      opRecord.waybillNo = entity.code; //"790000000545789";

      opRecord.modifyOrgCode = SystemConfigModule.loginData.orgCode;
      opRecord.modifyTerminal = "";
      opRecord.modifyTime = datetimeNow;
      opRecord.modifyUserCode = "";
      opRecord.modifyUserName = "";
      opRecord.nextOrgCode = entity.NextWebPoint; //"210901";
      opRecord.opCode = opCode;
      opRecord.orgCode = SystemConfigModule.loginData.orgCode;
      opRecord.uploadTime = datetimeNow;
      opRecord.transportTypeCode = "";
      opRecord.transferStatus = 0;
      opRecord.remark = "GetOn";
      opRecord.sourceOrgCode = SystemConfigModule.loginData.orgCode;
      opRecord.weighWeight = "0.0";
      opRecord.pkgWidth = entity.width;
      opRecord.pkgLength = entity.length;
      opRecord.pkgHeight = entity.height;
      opRecord.volumeWeight = entity.VolumnWeight;
      opRecord.pkgQty = 1;
      opRecord.lineNo = ""; //"104829";
      opRecord.previousOrgCode = "";
      opRecord.routeCode = "";
      stGetOnData.body.opRecord = opRecord;

      // stGetOnData.body.opRecord.customData = new CustomData_GetOn();
      let customData: any = {};
      customData.inOutDiff = "1";
      customData.lineFrequencyNo = ""; // "";

      if (ScanforGetOnModule.checked_IsOverTimeCar) {
        customData.otFlag = 1;
      } else {
        customData.otFlag = 0;
      }

      customData.refId = "";
      customData.returnPart = "";
      customData.vehiclePlateNo = "";
      customData.optArea = entity.optArea;
      customData.extend1 = this.GetAutoMode().toString();

      //单边
      customData.extend2 = "0";
      stGetOnData.body.opRecord.customData = customData;

      // MyHttpTransport myHttpTransport = new MyHttpTransport();
      let stReturn = this.GetOn(stGetOnData, entity.IsPackage);
      if (stReturn != null && stReturn.respcode != "000") {
        this.errormessage = stReturn.respMessage;
        if (stReturn.respcode == "101") {
          return 2;
        } else {
          return 1;
        }
      }

      return 0;
    } catch (ex) {
      LogHelper.WriteLog("ScnForGetOn:UploadDataFromDgvToServer()" + ex);
      return 1;
    }
  }
  private NewUploadDataFromDgvToServer(entity) {
    try {
      let stGetOnData: any = {};
      let datetimeNow = new Date().valueOf();
      let _opRecord: any = {};
      _opRecord.auxOpCode = "DELETE";
      _opRecord.containerNo = "";//2021年9月3日更新内容：删除时，不传车签，只传单号
      _opRecord.createOrgCode = SystemConfigModule.loginData.orgCode;
      _opRecord.createTerminal = SystemConfigModule.globalData.LocalIPv4;
      _opRecord.createTime = datetimeNow;
      _opRecord.createUserCode = SystemConfigModule.loginData.userCode;
      _opRecord.createUserName = SystemConfigModule.loginData.employeeName;
      _opRecord.desOrgCode = entity.NextWebPoint;
      _opRecord.deviceType = SystemConfigModule.globalData.CurrentDeviceType.toString();
      _opRecord.expType = 10;
      _opRecord.inOutFlag = SystemConfigModule.globalData.InOutFlag;
      _opRecord.ioType = entity.RecvType;
      _opRecord.waybillNo = entity.WayBillNo;
      _opRecord.modifyOrgCode = SystemConfigModule.loginData.orgCode;
      _opRecord.modifyTime = datetimeNow;
      _opRecord.nextOrgCode = entity.NextWebPoint;
      _opRecord.opCode = 131;
      _opRecord.orgCode = SystemConfigModule.loginData.orgCode;
      _opRecord.uploadTime = datetimeNow;
      _opRecord.remark = "GetOn";
      _opRecord.sourceOrgCode = SystemConfigModule.loginData.orgCode;
      _opRecord.pkgWidth = entity.width;
      _opRecord.pkgLength = entity.length;
      _opRecord.pkgHeight = entity.height;
      _opRecord.pkgQty = 1;
      _opRecord.lineNo = ""; //"104829";

      let _body: any = {};
      _body.opRecord = _opRecord;
      stGetOnData.body = _body;

      let _customData: any = {};
      if (ScanforGetOnModule.checked_IsOverTimeCar) {
        _customData.otFlag = 1;
      } else {
        _customData.otFlag = 0;
      }
      _customData.extend1 = this.GetAutoMode().toString();
      _customData.extend2 = "0";
      _customData.optArea =  entity.optArea;
      stGetOnData.body.opRecord.customData = _customData;


      // MyHttpTransport myHttpTransport = new MyHttpTransport();
      let stReturn = this.GetOn(stGetOnData, entity.IsPackage);
      if (stReturn != null && stReturn.respcode != "000") {
        this.errormessage = stReturn.respMessage;
        if (stReturn.respcode == "101") {
          return 2;
        } else {
          return 1;
        }
      }

      return 0;
    } catch (ex) {
      LogHelper.WriteLog("ScnForGetOn:UploadDataFromDgvToServer()" + ex);
      return 1;
    }
  }
  public GetOn(stGetOnData, bIsPackageCode = false, isFirstTransfer = 1) {
    let strResult = "";
    let stReturn: any = {};
    //double赋值0.0的时候，json序列化成0
    try {
      stGetOnData.body.isFirstTransfer = isFirstTransfer;
      //处理一些数据
      if (stGetOnData.body.opRecord.opCode == 130) {
        stGetOnData.body.opRecord.expType = 40;
      } else {
        if (
          stGetOnData.body.opRecord.waybillNo != null &&
          stGetOnData.body.opRecord.waybillNo.Length >= 3
        ) {
          if (bIsPackageCode) {
            stGetOnData.body.opRecord.expType = 20;
          } else {
            stGetOnData.body.opRecord.expType = 10;
          }
        }
      }

      let strResult = abord(JSON.stringify(stGetOnData));
      // strResult = HttpTransportBase.HttpPost(strUrl, jsonData);

      stReturn = JSON.parse(strResult);

      return stReturn;
    } catch (ex) {
      stReturn.respMessage = strResult;
      LogHelper.WriteLog("接口GetOn：" + strResult + "|" + ex);
      return stReturn;
      // return ex.Message;
    }
  }
  public GetAutoMode() {
    // SystemConfig tempsystemConfig = GetConfig();
    let tempsystemConfig = SystemConfigModule.systemData;
    let type = tempsystemConfig.ModeInfo.Mode_Type.toString();

    switch (type) {
      case "1": //快手
        if (tempsystemConfig.ModeInfo.ModeAdd_Type.toString() == "0") return 7;
        return 6;
      case "2": //DWS
      case "5":
      case "6":
      case "7":
        if (tempsystemConfig.ModeInfo.ModeAdd_Type.toString() == "0") return 13;
        return 12;
      case "3": //狂扫
        return 5;
      case "4": //手动
        return 0;
      default:
        return -1;
    }
  }
  public deletedatahistorycallback() {
    this.currentrow = null;
  }

  public selectElementContents(el) {
    el.blur();
    el.focus();
  }
  public NoticePlcMsg(cmd) {
    try {
      if (this.bIsRollInit) {
        obj_SerialPort_Core.hexWrite(cmd);
      } else {
        console.log("上车链接串口失败");
      }
    } catch (error) {
      console.log(error);
    }
  }

  private setCarLabel(label, cpCode = "") {
    this.inputModel.input_CarLabel = label;
    this.cpCode = cpCode;
  }

  private deviceItems: deviceItem[] = [];
  private errormessage = "";
  private currentRow = null;
  private tableshow = true;
}
